
const plantDatabase = {
    "Adzuki Beans": {
        "spacing": "4-6\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "80-120",
        "pests": "Bean beetles, Aphids, leafhoppers",
        "companions": "Corn, squash, radishes, carrots, cucumber, celery, summer savory",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 3,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [5,6],
        "plant": [5,6],
        "harvest": [8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 21,
        "notes": "Warm season legume, plant after last frost",
        "varieties": ["Takara", "Express"]
    },
    "Amaranth": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "45-75",
        "pests": "Aphids, Flea beetles, caterpillars",
        "companions": "Corn, beans, squash, cucumber, melons, peppers, eggplant, tomatoes",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "3-8 feet",
        "heightValue": 5.5,
        "shadeTolerance": "none",
        "shadeCreation": "moderate",
        "shadeRadius": 1.5,
        "sow": [4,5,6],
        "plant": [5,6],
        "harvest": [8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 75,
        "soilTempMax": 85,
        "successionInterval": 14,
        "notes": "Heat-loving grain crop, good for succession planting",
        "varieties": ["All Red Leaf", "Burgundy", "Golden Giant"]
    },
    "Artichokes": {
        "spacing": "36-48\"",
        "depth": "1/4-1/2\"",
        "soil": "Rich, well-drained soil",
        "soilTemperature": "55-65°F",
        "whenToPlant": "Early spring",
        "daysToMaturity": "85-100",
        "pests": "Aphids, slugs, snails",
        "companions": "Asparagus, basil, marigolds, borage, nasturtiums, chives, garlic, cucumbers",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "3-5 feet",
        "heightValue": 4,
        "shadeTolerance": "partial",
        "shadeCreation": "moderate",
        "shadeRadius": 1,
        "sow": [2,3],
        "plant": [4,5],
        "harvest": [6,7,8,9],
        "soilTempMin": 50,
        "soilTempOptimal": 65,
        "soilTempMax": 75,
        "successionInterval": null,
        "notes": "Perennial in zones 7+, treat as annual in colder zones",
        "varieties": ["Green Globe", "Imperial Star", "Tavor"]
    },
    "Arugula": {
        "spacing": "3-4\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "45-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "30-40",
        "pests": "Flea beetles, Aphids, cabbage worms",
        "companions": "Beets, carrots, dill, lettuce, onions, spinach, bok choy, bush beans",
        "sun": "Full sun to partial shade",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": 16,
        "height": "6-12 inches",
        "heightValue": 0.75,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5,8,9],
        "plant": [3,4,5,8,9],
        "harvest": [4,5,6,9,10,11],
        "soilTempMin": 40,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Cool season crop, bolts in heat. Excellent for succession",
        "varieties": ["Astro", "Rocket", "Wild Sylvetta"]
    },
    "Asparagus": {
        "spacing": "12-18\"",
        "depth": "6-8\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "50-75°F",
        "whenToPlant": "Early spring",
        "daysToMaturity": "730-1095 (2-3 years)",
        "pests": "Asparagus beetles, Aphids, slugs",
        "companions": "Basil, parsley, tomatoes, asters, dill, coriander, peppers, sage, thyme",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "3-7 feet",
        "heightValue": 5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 1,
        "sow": [2,3],
        "plant": [4,5],
        "harvest": [4,5,6],
        "soilTempMin": 50,
        "soilTempOptimal": 60,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Perennial crop, harvest for 6-8 weeks in spring",
        "varieties": ["Jersey Knight", "Mary Washington", "Purple Passion"]
    },
    "Asters": {
        "spacing": "12-18\"",
        "depth": "1/4\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring to early summer",
        "daysToMaturity": "85-100",
        "pests": "Aphids, spider mites, slugs",
        "companions": "Goldenrod, ornamental grasses, coneflowers, zinnias, marigolds, sunflowers",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "1 - 3",
        "height": "1-5 feet",
        "heightValue": 3,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4],
        "plant": [5,6],
        "harvest": [8,9,10],
        "soilTempMin": 55,
        "soilTempOptimal": 65,
        "soilTempMax": 75,
        "successionInterval": null,
        "notes": "Native wildflower, attracts pollinators",
        "varieties": ["Alpine", "New England", "Powwow"]
    },
    "Basil": {
        "spacing": "8-12\"",
        "depth": "1/4\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "60-90",
        "pests": "Japanese beetles, slugs, Aphids",
        "companions": "Tomatoes, peppers, oregano, asparagus, chamomile, anise, borage, chives, turnip",
        "sun": "Full sun",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 21,
        "notes": "Very heat sensitive, pinch flowers to maintain leaf production",
        "varieties": ["Genovese", "Thai", "Lemon", "Purple Ruffles"]
    },
    "Bay Leaf": {
        "spacing": "36-48\"",
        "depth": "1/4\"",
        "soil": "Well-drained soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "730 (2 years)",
        "pests": "Scale insects, Aphids, mealybugs",
        "companions": "Beans, rosemary, sage, thyme, parsley",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "up to 30 feet (tree)",
        "heightValue": 15,
        "shadeTolerance": "partial",
        "shadeCreation": "moderate to heavy",
        "shadeRadius": 5,
        "sow": [3,4],
        "plant": [5,6],
        "harvest": [6,7,8,9,10,11,12],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Perennial herb tree, grow in containers in cold zones",
        "varieties": ["Laurus nobilis"]
    },
    "Beans": {
        "spacing": "3-6\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "60-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "50-65",
        "pests": "Bean beetles, Aphids, leafhoppers",
        "companions": "Corn, squash, cucumber, carrots, cauliflower, cabbage, peas, beets, lettuce",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 9,
        "height": "1-10 feet (depending on type)",
        "heightValue": 5.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1,
        "sow": [5,6,7],
        "plant": [5,6,7],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 14,
        "notes": "Direct sow, succession plant bush varieties",
        "varieties": ["Blue Lake", "Kentucky Wonder", "Scarlet Runner"]
    },
    "Beets": {
        "spacing": "3-4\"",
        "depth": "1/2\"",
        "soil": "Well-drained, loose soil",
        "soilTemperature": "50-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "50-70",
        "pests": "Leaf miners, Aphids, Flea beetles",
        "companions": "Onions, kohlrabi, lettuce, cabbage, broccoli, brussels sprouts, chard, spinach",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 9,
        "height": "1-2 feet (foliage)",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5,7,8],
        "plant": [3,4,5,7,8],
        "harvest": [6,7,8,9,10,11],
        "soilTempMin": 40,
        "soilTempOptimal": 60,
        "soilTempMax": 85,
        "successionInterval": 14,
        "notes": "Cool season crop, both roots and greens edible",
        "varieties": ["Detroit Dark Red", "Bull's Blood", "Chioggia"]
    },
    "Begonias": {
        "spacing": "8-12\"",
        "depth": "1/8\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "70-80",
        "pests": "Aphids, mealybugs, powdery mildew",
        "companions": "Hostas, ferns, impatiens, coleus, caladiums, fuchsias",
        "sun": "Partial shade",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": 1,
        "height": "6 inches - 3 feet (depending on type)",
        "heightValue": 1.75,
        "shadeTolerance": "partial to full",
        "shadeCreation": "very light to light",
        "shadeRadius": 0.5,
        "sow": [1,2],
        "plant": [5,6],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 70,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Tender annual, start seeds 3-4 months before last frost",
        "varieties": ["Tuberous", "Rex", "Wax"]
    },
    "Bell Pepper": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "60-90",
        "pests": "Aphids, Flea beetles, cutworms",
        "companions": "Basil, carrots, eggplant, onions, parsley, tomatoes, geraniums, lovage",
        "sun": "Full sun",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": 1,
        "varieties": ["California Wonder", "King of the North", "Keystone Giant"],
        "height": "2-3 feet",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [2,3,4],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Warm season crop, needs consistent heat"
    },
    "Bitter Gourd": {
        "spacing": "36-48\"",
        "depth": "1/2-1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "65-70",
        "pests": "Cucumber beetles, Aphids, fruit flies",
        "companions": "Beans, peas, pumpkins, summer squashes, radishes, corn, okra",
        "sun": "Full sun",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": "1 - 2",
        "height": "6-15 feet (vine)",
        "heightValue": 10.5,
        "shadeTolerance": "partial",
        "shadeCreation": "moderate",
        "shadeRadius": 2,
        "sow": [4,5],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Tropical vine, needs long warm season",
        "varieties": ["Indian Long", "Green Skin"]
    },
    "Bitter Melon": {
        "spacing": "36-48\"",
        "depth": "1/2-1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "65-70",
        "pests": "Cucumber beetles, Aphids, fruit flies",
        "companions": "Beans, corn, peas, pumpkins, squash, radishes, okra",
        "sun": "Full sun",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": "1 - 2",
        "height": "6-15 feet (vine)",
        "heightValue": 10.5,
        "shadeTolerance": "partial",
        "shadeCreation": "moderate",
        "shadeRadius": 2,
        "sow": [4,5],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Same as bitter gourd, tropical climbing vine",
        "varieties": ["Indian Long", "Chinese Bitter", "Green Skin"]
    },
    "Black-eyed Peas": {
        "spacing": "4-6\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "60-70",
        "pests": "Aphids, pod borers, leafhoppers",
        "companions": "Corn, squash, radishes, collard greens, okra, sweet potatoes, peppers",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet (bush) or vining",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [5,6],
        "plant": [5,6],
        "harvest": [8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 21,
        "notes": "Heat-loving legume, drought tolerant",
        "varieties": ["California Blackeye No. 5", "Mississippi Silver"]
    },
    "Black-eyed Susans": {
        "spacing": "12-18\"",
        "depth": "1/4\"",
        "soil": "Well-drained soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "80-100",
        "pests": "Aphids, Japanese beetles, powdery mildew",
        "companions": "Coneflowers, ornamental grasses, asters, chrysanthemums, goldenrod",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "2-3 feet",
        "heightValue": 2.5,
        "shadeTolerance": "none",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 55,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Native wildflower, perennial in most zones",
        "varieties": ["Goldsturm", "Toto", "Indian Summer"]
    },
    "Bok Choy": {
        "spacing": "6-8\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "50-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "45-50",
        "pests": "Cabbage worms, Flea beetles, Aphids",
        "companions": "Onions, garlic, rosemary, mint, celery, cilantro, marigolds, carrots, lettuce, spinach",
        "sun": "Full sun to partial shade",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,8,9],
        "plant": [3,4,8,9],
        "harvest": [5,6,7,9,10,11],
        "soilTempMin": 40,
        "soilTempOptimal": 60,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Cool season Asian green, succession plant for continuous harvest",
        "varieties": ["Joi Choi", "Win-Win", "Baby Bok Choy"]
    },
    "Borage": {
        "spacing": "12-18\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "50-60",
        "pests": "Aphids, whiteflies, powdery mildew",
        "companions": "Tomatoes, squash, strawberries, cucumber, beans, peas, herbs",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "2-3 feet",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4,5],
        "plant": [4,5,6],
        "harvest": [6,7,8,9],
        "soilTempMin": 50,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": 28,
        "notes": "Self-seeding annual herb, edible flowers",
        "varieties": ["Common Blue"]
    },
    "Broad Beans": {
        "spacing": "6-8\"",
        "depth": "1-2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "50-65°F",
        "whenToPlant": "Early spring or fall",
        "daysToMaturity": "80-100",
        "pests": "Black bean Aphids, chocolate spot, bean rust",
        "companions": "Potatoes, corn, spinach, lettuce, summer savory, dill",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "2-5 feet",
        "heightValue": 3.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1,
        "sow": [2,3,4,10,11],
        "plant": [3,4,5,11,12],
        "harvest": [5,6,7,8],
        "soilTempMin": 35,
        "soilTempOptimal": 60,
        "soilTempMax": 75,
        "successionInterval": 21,
        "notes": "Very cold hardy, plant early spring or fall",
        "varieties": ["Windsor", "Aquadulce", "Sweet Lorane"]
    },
    "Broccoli": {
        "spacing": "18\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "55-85",
        "pests": "Cabbage worms, Aphids, Flea beetles",
        "companions": "Celery, chamomile, dill, mint, onions, oregano, potatoes, rosemary, sage, beets",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "2-3 feet",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [2,3,7,8],
        "plant": [4,5,8,9],
        "harvest": [6,7,8,10,11,12],
        "soilTempMin": 45,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": 14,
        "notes": "Cool season crop, plant spring and fall",
        "varieties": ["Waltham 29", "Calabrese", "Di Cicco"]
    },
    "Brussel Sprout": {
        "spacing": "18-24\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "60-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "90-110",
        "pests": "Cabbage worms, Aphids, cabbage loopers",
        "companions": "Beans, beets, carrots, dill, lettuce, mint, nasturtium, onions, potatoes, sage, thyme",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "2-3 feet",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [4,5,6],
        "plant": [6,7,8],
        "harvest": [10,11,12,1,2],
        "soilTempMin": 45,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Very cold hardy, flavor improves after frost",
        "varieties": ["Long Island Improved", "Jade Cross"]
    },
    "Bush Beans": {
        "spacing": "3-6\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "60-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "50-55",
        "pests": "Bean beetles, Aphids, leafhoppers",
        "companions": "Beets, broccoli, cabbage,cauliflower, celery, corn, cucumber, potatoes, radish, tomatoes",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 9,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [5,6,7],
        "plant": [5,6,7],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 14,
        "notes": "Excellent for succession planting, harvest all at once",
        "varieties": ["Blue Lake 274", "Contender", "Provider"]
    },
    "Cabbage": {
        "spacing": "12-24\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "60-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "70-100",
        "pests": "Cabbage worms, Aphids, Flea beetles",
        "companions": "Onions, beets, celery, herbs, potatoes, dill, rosemary, sage, thyme, garlic, borage",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [2,3,7,8],
        "plant": [4,5,8,9],
        "harvest": [6,7,8,10,11,12],
        "soilTempMin": 45,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": 21,
        "notes": "Cool season crop, spring and fall plantings",
        "varieties": ["Early Jersey Wakefield", "Golden Acre", "Red Acre"]
    },
    "Calendula": {
        "spacing": "12-18\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "60-65°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "50-70",
        "pests": "Aphids, whiteflies, powdery mildew",
        "companions": "Tomatoes, roses, beans, lettuce, marigolds, nasturtiums",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5,8,9],
        "plant": [4,5,6,9,10],
        "harvest": [6,7,8,9,10,11],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 75,
        "successionInterval": 21,
        "notes": "Edible flower, self-seeding annual, good companion plant",
        "varieties": ["Pacific Beauty", "Pot Marigold", "Alpha"]
    },
    "Cantaloupe": {
        "spacing": "24-36\"",
        "depth": "1\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "70-90°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "75-90",
        "pests": "Cucumber beetles, squash bugs, Aphids",
        "companions": "Corn, pumpkins, radishes, squash, marigolds, nasturtiums, oregano, lettuce, beans",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "Vine 1",
        "height": "vining, spreads 3-6 feet",
        "heightValue": 3,
        "shadeTolerance": "none",
        "shadeCreation": "light",
        "shadeRadius": 1.5,
        "sow": [4,5],
        "plant": [5,6],
        "harvest": [7,8,9],
        "soilTempMin": 70,
        "soilTempOptimal": 85,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Heat-loving vine crop, needs long warm season",
        "varieties": ["Hale's Best", "Ambrosia", "Hearts of Gold"]
    },
    "Caraway": {
        "spacing": "6-8\"",
        "depth": "1/4\"",
        "soil": "Well-drained soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring",
        "daysToMaturity": "70-80",
        "pests": "Aphids, carrot rust flies, cutworms",
        "companions": "Peas, lettuce, onions, leeks, cabbage",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,8,9],
        "plant": [4,5,9,10],
        "harvest": [6,7,8],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 75,
        "successionInterval": null,
        "notes": "Biennial herb, harvest seeds in second year",
        "varieties": ["Common Caraway"]
    },
    "Carrots": {
        "spacing": "2-3\"",
        "depth": "1/4\"",
        "soil": "Loose, well-drained, sandy soil",
        "soilTemperature": "55-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "60-80",
        "pests": "Carrot rust flies, Aphids, cutworms, nematodes",
        "companions": "Peas, lettuce, chives, onions, leeks, sage, tomatoes, radishes, beans",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 16,
        "height": "1-2 feet (foliage)",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5,6,7],
        "plant": [3,4,5,6,7],
        "harvest": [6,7,8,9,10,11],
        "soilTempMin": 45,
        "soilTempOptimal": 65,
        "soilTempMax": 85,
        "successionInterval": 14,
        "notes": "Direct sow only, excellent for succession planting",
        "varieties": ["Nantes", "Danvers 126", "Imperator 58"]
    },
    "Catnip": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "80-90",
        "pests": "Aphids, spider mites, leafhoppers",
        "companions": "Beets, pumpkins, squash, beans, tomatoes",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [6,7,8,9],
        "soilTempMin": 55,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Perennial herb, self-seeding",
        "varieties": ["Common Catnip", "Lemon Catnip"]
    },
    "Cauliflower": {
        "spacing": "18-24\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "60-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "55-100",
        "pests": "Cabbage worms, Aphids, Flea beetles",
        "companions": "Beans, beets, celery, chamomile, oregano, potatoes, sage, spinach",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [2,3,7,8],
        "plant": [4,5,8,9],
        "harvest": [6,7,8,10,11],
        "soilTempMin": 45,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": 21,
        "notes": "Cool season crop, more heat sensitive than broccoli",
        "varieties": ["Snowball Y", "Early White", "Romanesco"]
    },
    "Celeriac": {
        "spacing": "6-8\"",
        "depth": "1/8\"",
        "soil": "Moist, rich, well-drained soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring",
        "daysToMaturity": "100-120",
        "pests": "Aphids, carrot rust flies, slugs",
        "companions": "Onions, brassicas, spinach, tomatoes, bush beans, cucumber, leeks",
        "sun": "Full sun",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet (foliage)",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [2,3,4],
        "plant": [5,6],
        "harvest": [9,10,11,12],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Long season crop, start early indoors",
        "varieties": ["Mars", "Monarch", "Brilliant"]
    },
    "Celery": {
        "spacing": "6-8\"",
        "depth": "1/8\"",
        "soil": "Moist, rich, well-drained soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring",
        "daysToMaturity": "85-120",
        "pests": "Aphids, slugs, snails, root-knot nematodes",
        "companions": "Leeks, tomatoes, bush beans, cauliflower, cabbage, spinach, cucumber, garlic",
        "sun": "Full sun to partial shade",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [2,3,4],
        "plant": [5,6],
        "harvest": [8,9,10,11],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": 21,
        "notes": "Needs consistent moisture, start early indoors",
        "varieties": ["Utah 52-70", "Tall Utah", "Conquistador"]
    },
    "Chamomile": {
        "spacing": "6-12\"",
        "depth": "1/4\"",
        "soil": "Well-drained soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "60-65",
        "pests": "Aphids, thrips, mealybugs",
        "companions": "Cabbage, onions, beans, cucumber, basil, broccoli, kale, brussels sprouts",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "6-24 inches",
        "heightValue": 1.25,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.5,
        "sow": [3,4,5,8,9],
        "plant": [4,5,6,9,10],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 55,
        "soilTempOptimal": 65,
        "soilTempMax": 75,
        "successionInterval": 28,
        "notes": "Self-seeding annual, harvest flowers"
    },
    "Chervil": {
        "spacing": "6-9\"",
        "depth": "1/4\"",
        "soil": "Rich, moist, well-drained soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "40-60",
        "pests": "Aphids, slugs, whiteflies",
        "companions": "Radishes, lettuce, broccoli, asparagus",
        "sun": "Partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,8,9],
        "plant": [3,4,8,9],
        "harvest": [5,6,7,9,10,11],
        "soilTempMin": 40,
        "soilTempOptimal": 55,
        "soilTempMax": 70,
        "successionInterval": 14,
        "notes": "Cool season herb, bolts in heat",
        "varieties": ["Brussels Winter", "Curled"]
    },
    "Chilli Peppers": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "65-85",
        "pests": "Aphids, pepper maggots, spider mites",
        "companions": "Basil, oregano, parsley, carrots, onions, eggplant, tomatoes",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-3 feet",
        "heightValue": 3,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [2,3,4],
        "plant": [5,6],
        "harvest": [7,8,9,10,11],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Very heat loving, longer season than sweet peppers",
        "varieties": ["Habanero", "Cayenne Long Slim", "Thai Hot"]
    },
    "Chinese Cabbage": {
        "spacing": "12-18\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "60-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "45-70",
        "pests": "Cabbage worms, Aphids, Flea beetles",
        "companions": "Onions, garlic, carrots, beets, spinach, chard, celery",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [6,7,8],
        "plant": [7,8,9],
        "harvest": [9,10,11,12],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Fall crop, bolts quickly in long days",
        "varieties": ["Michihli", "Napa", "Pe-Tsai"]
    },
    "Chives": {
        "spacing": "6-8\"",
        "depth": "1/4\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring",
        "daysToMaturity": "80-90",
        "pests": "Aphids, thrips, Onion maggots",
        "companions": "Carrots, tomatoes, roses, cabbage, eggplant, peppers, potatoes, strawberries",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5,8,9],
        "plant": [4,5,6,9,10],
        "harvest": [5,6,7,8,9,10],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Hardy perennial herb, cut and come again",
        "varieties": ["Common Chives", "Garlic Chives"]
    },
    "Chrysanthemums": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "90-100",
        "pests": "Aphids, spider mites, thrips",
        "companions": "Asters, goldenrod, ornamental grasses, salvia, coneflowers, marigolds, alyssum",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [2,3,4],
        "plant": [5,6],
        "harvest": [9,10,11],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Fall flowering perennial",
        "varieties": ["Mammoth Daisy", "Clara Curtis"]
    },
    "Cilantro": {
        "spacing": "4-6\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "55-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "30-45",
        "pests": "Aphids, whiteflies, mites",
        "companions": "Anise, cabbage, spinach, lettuce, tomatoes, beans, peas",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 9,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5,8,9],
        "plant": [3,4,5,8,9],
        "harvest": [5,6,7,9,10,11],
        "soilTempMin": 40,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Cool season herb, bolts quickly in heat. Essential for succession",
        "varieties": ["Santo", "Slo-Bolt", "Leisure"]
    },
    "Cinnamon": {
        "spacing": "24-36\"",
        "depth": "1/4\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "75-85°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "1825-2555 (5-7 years)",
        "pests": "Scale insects, mealybugs, ants",
        "companions": "Cloves, ginger, nutmeg, cardamom",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "1p 2sqft",
        "height": "up to 60 feet (tree)",
        "heightValue": 30,
        "shadeTolerance": "partial",
        "shadeCreation": "moderate to heavy",
        "shadeRadius": 10,
        "sow": [3,4],
        "plant": [5,6],
        "harvest": [12,1,2],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Tropical tree, not suitable for temperate outdoor growing",
        "varieties": ["Ceylon"]
    },
    "Citronella Grass": {
        "spacing": "24-36\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "120-150",
        "pests": "Spider mites, scale insects, mealybugs",
        "companions": "Lemongrass, lavender, rosemary, basil, marigolds",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "3-6 feet",
        "heightValue": 4.5,
        "shadeTolerance": "none",
        "shadeCreation": "light",
        "shadeRadius": 1,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Tropical grass, natural mosquito repellent, grow in containers in temperate zones",
        "varieties": ["Pelargonium citrosum"]
    },
    "Clematis": {
        "spacing": "12-18\"",
        "depth": "2-3\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "365-730 (1-2 years)",
        "pests": "Aphids, clematis wilt, powdery mildew",
        "companions": "Roses, shrubs, small trees, perennials that provide shade to roots",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "vining, 6-20+ feet",
        "heightValue": 13,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate (depending on foliage)",
        "shadeRadius": 2,
        "sow": [3,4],
        "plant": [5,6,9,10],
        "harvest": [6,7,8,9],
        "soilTempMin": 50,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Perennial flowering vine",
        "varieties": ["Nelly Moser", "Jackmanii", "Sweet Autumn"]
    },
    "Climbing Beans": {
        "spacing": "4-6\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "60-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "55-65",
        "pests": "Bean beetles, Aphids, leafhoppers",
        "companions": "Corn, sunflowers, radishes, carrots, cucumber, summer savory",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 8,
        "height": "6-10 feet (vine)",
        "heightValue": 8,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1.5,
        "sow": [5,6],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 21,
        "notes": "Longer harvest period than bush beans",
        "varieties": ["Kentucky Wonder", "Blue Lake Pole"]
    },
    "Collard": {
        "spacing": "18-24\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "60-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "60-80",
        "pests": "Cabbage worms, Aphids, Flea beetles",
        "companions": "Tomatoes, onions, garlic, herbs, black-eyed peas, thyme",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 0.25,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4,7,8],
        "plant": [4,5,8,9],
        "harvest": [6,7,8,10,11,12],
        "soilTempMin": 45,
        "soilTempOptimal": 65,
        "soilTempMax": 85,
        "successionInterval": 21,
        "notes": "Very cold hardy, cut and come again",
        "varieties": ["Georgia Southern", "Champion"]
    },
    "Collard Greens": {
        "spacing": "18-24\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "60-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "60-80",
        "pests": "Cabbage worms, Aphids, Flea beetles",
        "companions": "Tomatoes, onions, garlic, thyme, rosemary, black-eyed peas, okra, beans",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 0.25,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4,7,8],
        "plant": [4,5,8,9],
        "harvest": [6,7,8,10,11,12],
        "soilTempMin": 45,
        "soilTempOptimal": 65,
        "soilTempMax": 85,
        "successionInterval": 21,
        "notes": "Same as collard - duplicate entry",
        "varieties": ["Georgia Southern", "Champion"]
    },
    "Columbines": {
        "spacing": "12-18\"",
        "depth": "1/4\"",
        "soil": "Well-drained soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "90-120",
        "pests": "Leaf miners, Aphids, powdery mildew",
        "companions": "Ferns, hostas, heuchera, astilbe, bleeding hearts",
        "sun": "Partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 0.5,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.5,
        "sow": [3,4,9,10],
        "plant": [5,6,10,11],
        "harvest": [5,6,7,8],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 75,
        "successionInterval": null,
        "notes": "Short-lived perennial, self-seeds",
        "varieties": ["McKana Giant", "Eastern Red"]
    },
    "Coneflowers": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "90-120",
        "pests": "Japanese beetles, Aphids, eriophyid mites",
        "companions": "Black-eyed susans, ornamental grasses, yarrow, sedum, asters, goldenrod",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "2-5 feet",
        "heightValue": 3.5,
        "shadeTolerance": "none",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 55,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Native perennial, attracts pollinators",
        "varieties": ["Magnus", "PowWow Wild Berry", "Cheyenne Spirit"]
    },
    "Coriander": {
        "spacing": "4-6\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "55-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "30-45",
        "pests": "Aphids, whiteflies, mites",
        "companions": "Anise, cabbage, spinach, lettuce, tomatoes, beans, peas, basil, dill",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5,8,9],
        "plant": [3,4,5,8,9],
        "harvest": [5,6,7,9,10,11],
        "soilTempMin": 40,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Same plant as cilantro, harvest seeds when bolted"
    },
    "Corn": {
        "spacing": "8-12\"",
        "depth": "1-2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "60-100",
        "pests": "Corn earworms, corn borers, Aphids",
        "companions": "Beans, beets, cucumber, dill, melons, parsley, peas, potatoes, sunflower, amaranth",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "5-12 feet",
        "heightValue": 8.5,
        "shadeTolerance": "none",
        "shadeCreation": "moderate",
        "shadeRadius": 1,
        "sow": [5,6],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 14,
        "notes": "Plant in blocks for pollination, succession plant for extended harvest",
        "varieties": ["Silver Queen", "Bodacious", "Golden Bantam"]
    },
    "Cosmos": {
        "spacing": "12-18\"",
        "depth": "1/4\"",
        "soil": "Well-drained soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "70-90",
        "pests": "Aphids, Japanese beetles, slugs",
        "companions": "Tomatoes, beets, marigolds, zinnias, cleome, nicotiana",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 4,
        "height": "1-6 feet",
        "heightValue": 3.5,
        "shadeTolerance": "none",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [4,5,6],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": 28,
        "notes": "Easy annual flower, self-seeds"
    },
    "Cucumber": {
        "spacing": "12-18\"",
        "depth": "1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "50-70",
        "pests": "Cucumber beetles, Aphids, powdery mildew",
        "companions": "Beans, corn, peas, radishes, lettuce, nasturtiums, dill, onions, beets, carrots",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "vining, 6-12 feet",
        "heightValue": 9,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1.5,
        "sow": [4,5,6],
        "plant": [5,6,7],
        "harvest": [7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 21,
        "notes": "Warm season vine, succession plant for continuous harvest",
        "varieties": ["Marketmore 76", "Straight Eight", "National Pickling"]
    },
    "Culantro": {
        "spacing": "6-8\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "90-120",
        "pests": "Aphids, whiteflies, spider mites",
        "companions": "Tomatoes, peppers, lettuce, basil",
        "sun": "Partial shade",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": "1 - 9",
        "height": "6-12 inches",
        "heightValue": 0.75,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [4,5],
        "plant": [5,6],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 28,
        "notes": "Tropical herb, stronger flavor than cilantro",
        "varieties": ["NG Ngo Gai"]
    },
    "Curry Leaf": {
        "spacing": "36-48\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "730-1095 (2-3 years)",
        "pests": "Scale insects, Aphids, mealybugs",
        "companions": "Ginger, turmeric, lemongrass, chilli peppers, tomatoes",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "1p 3sqft",
        "height": "up to 20 feet (small tree)",
        "heightValue": 10,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 3,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [6,7,8,9,10,11,12],
        "soilTempMin": 65,
        "soilTempOptimal": 75,
        "soilTempMax": 90,
        "successionInterval": null,
        "notes": "Tropical tree, grow in containers in temperate zones",
        "varieties": ["Murraya koenigii"]
    },
    "Cushaw Squash": {
        "spacing": "36-48\"",
        "depth": "1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "85-120",
        "pests": "Squash bugs, cucumber beetles, squash vine borers",
        "companions": "Corn, beans, radishes, nasturtiums, marigolds, oregano, tansy",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "vining, spreads 10-20 feet",
        "heightValue": 15,
        "shadeTolerance": "none",
        "shadeCreation": "moderate",
        "shadeRadius": 3,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [8,9,10,11],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Winter squash variety, needs long season",
        "varieties": ["Green Striped", "White Cushaw"]
    },
    "Daffodils": {
        "spacing": "4-6\"",
        "depth": "6\"",
        "soil": "Well-drained soil",
        "soilTemperature": "55-65°F",
        "whenToPlant": "Fall",
        "daysToMaturity": "150-180",
        "pests": "Bulb flies, narcissus nematodes, slugs",
        "companions": "Tulips, hyacinths, alliums, grape hyacinths, pansies, primrose",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": "4 - 5",
        "height": "6-20 inches",
        "heightValue": 1,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [9,10,11],
        "plant": [10,11,12],
        "harvest": [3,4,5],
        "soilTempMin": 35,
        "soilTempOptimal": 45,
        "soilTempMax": 55,
        "successionInterval": null,
        "notes": "Plant bulbs in fall for spring flowers",
        "varieties": ["King Alfred", "Tête-à-tête", "Dutch Master"]
    },
    "Dahlias": {
        "spacing": "18-24\"",
        "depth": "4-6\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "90-120",
        "pests": "Aphids, spider mites, thrips",
        "companions": "Zinnias, marigolds, nasturtiums, sunflowers, cosmos, geraniums, peonies, roses",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-6 feet",
        "heightValue": 3.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 1,
        "sow": [2,3,4],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Tender bulb, dig up tubers after frost",
        "varieties": ["Cafe au Lait", "Dinnerplate", "Pompon"]
    },
    "Daikon Radish": {
        "spacing": "3-4\"",
        "depth": "1/2\"",
        "soil": "Loose, sandy, well-drained soil",
        "soilTemperature": "50-70°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "50-65",
        "pests": "Flea beetles, root maggots, Aphids",
        "companions": "Peas, lettuce, spinach, beans, carrots",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 9,
        "height": "1-2 feet (foliage)",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [7,8,9],
        "plant": [7,8,9],
        "harvest": [10,11,12,1],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": 14,
        "notes": "Large Asian radish, fall crop, very cold hardy",
        "varieties": ["Miyashige", "Minowase", "Tokinashi"]
    },
    "Daisies": {
        "spacing": "24- 30\"",
        "depth": "1/4\"",
        "soil": "Well-drained soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "90-120",
        "pests": "Aphids, leafhoppers, spider mites",
        "companions": "Lavender, salvia, coneflowers, black-eyed susans, yarrow",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.5,
        "sow": [3,4,5,9,10],
        "plant": [5,6,10,11],
        "harvest": [6,7,8,9],
        "soilTempMin": 55,
        "soilTempOptimal": 65,
        "soilTempMax": 75,
        "successionInterval": null,
        "notes": "Perennial flower, blooms first year from seed",
        "varieties": ["Shasta", "Painted Daisy"]
    },
    "Dandelion Greens": {
        "spacing": "6-12\"",
        "depth": "1/4\"",
        "soil": "Well-drained soil",
        "soilTemperature": "50-75°F",
        "whenToPlant": "Early spring or fall",
        "daysToMaturity": "45-60",
        "pests": "Aphids, slugs, snails",
        "companions": "Tomatoes, fruit trees, clover, beans",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": 4,
        "height": "4-12 inches",
        "heightValue": 0.75,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,8,9],
        "plant": [3,4,8,9],
        "harvest": [4,5,6,9,10,11],
        "soilTempMin": 40,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": 21,
        "notes": "Cool season green, less bitter when young",
        "varieties": ["French Improved", "Italian"]
    },
    "Delicata Squash": {
        "spacing": "36-48\"",
        "depth": "1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "80-100",
        "pests": "Squash bugs, cucumber beetles, squash vine borers",
        "companions": "Corn, beans, radishes, nasturtiums, marigolds, oregano",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 0.06,
        "height": "vining, spreads 3-6 feet",
        "heightValue": 4.5,
        "shadeTolerance": "none",
        "shadeCreation": "light",
        "shadeRadius": 1.5,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [8,9,10,11],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Winter squash, shorter season than most",
        "varieties": ["Bush Delicata", "Honey Boat"]
    },
    "Dill": {
        "spacing": "6-9\"",
        "depth": "1/4\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "40-60",
        "pests": "Aphids, parsleyworms, carrot rust flies",
        "companions": "Broccoli, brussels sprouts, cabbage, cauliflower, cucumber, lettuce, onions, corn",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "2-4 feet",
        "heightValue": 3,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.5,
        "sow": [3,4,5,6,7],
        "plant": [3,4,5,6,7],
        "harvest": [5,6,7,8,9],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": 14,
        "notes": "Bolts quickly, succession plant for continuous harvest",
        "varieties": ["Mammoth", "Bouquet", "Fernleaf"]
    },
    "Dragon Tongue Beans": {
        "spacing": "4-6\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "60-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "55-60",
        "pests": "Bean beetles, Aphids, leafhoppers",
        "companions": "Corn, squash, radishes, marigold, nasturtium, summer savory",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "2-3 feet (bush) or vining",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 0.75,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [7,8,9],
        "soilTempMin": 60,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 14,
        "notes": "Bush bean variety with purple streaks",
        "varieties": ["Dragon Tongue"]
    },
    "Edamame": {
        "spacing": "12-18\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "65-85",
        "pests": "Japanese beetles, Aphids, bean beetles",
        "companions": "Corn, squash, radishes, carrots, lettuce, cucumber",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "4 - 9",
        "height": "2-3 feet",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 75,
        "soilTempMax": 90,
        "successionInterval": 21,
        "notes": "Soybean variety, harvest when pods are plump"
    },
    "Eggplant": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "65-80",
        "pests": "Flea beetles, Aphids, tomato hornworms",
        "companions": "Beans, peas, peppers, potatoes, spinach, tarragon, thyme, amaranth, basil, marigold",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "2-4 feet",
        "heightValue": 3,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [2,3,4],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 70,
        "soilTempOptimal": 85,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Very heat loving, needs long warm season",
        "varieties": ["Black Beauty", "Ichiban", "Rosa Bianca"]
    },
    "Endive": {
        "spacing": "8-10\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "45-95",
        "pests": "Aphids, slugs, leaf miners",
        "companions": "Radishes, carrots, beans, strawberries",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [6,7,8],
        "plant": [7,8,9],
        "harvest": [9,10,11,12],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Cool season bitter green, fall crop",
        "varieties": ["Batavian Full Heart", "Green Curled"]
    },
    "Fava Beans": {
        "spacing": "6-8\"",
        "depth": "1-2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "50-65°F",
        "whenToPlant": "Early spring or fall",
        "daysToMaturity": "75-85",
        "pests": "Aphids, bean beetles, leafhoppers",
        "companions": "Potatoes, corn, spinach, lettuce, cabbage family, strawberries",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "2-5 feet",
        "heightValue": 3.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1,
        "sow": [2,3,4,10,11],
        "plant": [3,4,5,11,12],
        "harvest": [5,6,7,8],
        "soilTempMin": 35,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": 21,
        "notes": "Very cold hardy, can overwinter in mild areas"
    },
    "Fennel": {
        "spacing": "30-40\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring and late summer",
        "daysToMaturity": "90-115",
        "pests": "Aphids, slugs, cutworms",
        "companions": "Grow alone or with other Mediterranean herbs",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "2-3 feet (foliage)",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4,5,8,9],
        "plant": [4,5,6,9,10],
        "harvest": [6,7,8,10,11],
        "soilTempMin": 50,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": 21,
        "notes": "Herb fennel for leaves, different from bulb fennel",
        "varieties": ["Florence", "Perfection", "Zefa Fino"]
    },
    "Foxgloves": {
        "spacing": "12-14\"",
        "depth": "1/8\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "365-730 (1-2 years)",
        "pests": "Aphids, slugs, powdery mildew",
        "companions": "Hostas, ferns, astilbe, bleeding hearts, heuchera",
        "sun": "Partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "2-5 feet",
        "heightValue": 3.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [5,6,7],
        "plant": [8,9,10],
        "harvest": [6,7,8],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Biennial, flowers in second year - POISONOUS",
        "varieties": ["Excelsior", "Dalmatian Series"]
    },
    "Galangal": {
        "spacing": "12-18\"",
        "depth": "2-3\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "180-240",
        "pests": "Aphids, spider mites, whiteflies",
        "companions": "Ginger, turmeric, lemongrass, kaffir lime, chilli peppers, cardamom",
        "sun": "Partial shade",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": 1,
        "height": "4-6 feet",
        "heightValue": 5,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [10,11,12],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Tropical rhizome, grow in containers in temperate zones",
        "varieties": ["Alpinia galanga"]
    },
    "Garden Peas": {
        "spacing": "2-3\"",
        "depth": "1\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "45-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "55-70",
        "pests": "Aphids, pea moths, powdery mildew",
        "companions": "Carrots, radishes, corn, cucumber, beans, turnips, lettuce",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "8 - 9",
        "height": "2-6 feet (vining)",
        "heightValue": 4,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1,
        "sow": [2,3,4,8,9],
        "plant": [3,4,5,9,10],
        "harvest": [5,6,7,10,11],
        "soilTempMin": 35,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Very cold hardy, succession plant for extended harvest",
        "varieties": ["Green Arrow", "Lincoln", "Little Marvel"]
    },
    "Garlic": {
        "spacing": "4-6\"",
        "depth": "1-2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "50-65°F",
        "whenToPlant": "Fall or early spring",
        "daysToMaturity": "180-240",
        "pests": "Onion maggots, thrips, nematodes",
        "companions": "Roses, raspberries, beets, broccoli, carrots, lettuce, peppers, potatoes, tomatoes",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": "4 - 9",
        "height": "1-2 feet (foliage)",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [9,10,11],
        "plant": [10,11,12],
        "harvest": [6,7,8],
        "soilTempMin": 32,
        "soilTempOptimal": 45,
        "soilTempMax": 65,
        "successionInterval": null,
        "notes": "Plant cloves in fall, harvest following summer",
        "varieties": ["California Early", "Music", "German White"]
    },
    "Geraniums": {
        "spacing": "6-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "75-90",
        "pests": "Aphids, whiteflies, spider mites",
        "companions": "Roses, tomatoes, peppers, grapes, corn, dahlias",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 4,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [2,3,4],
        "plant": [5,6],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Tender perennial, treat as annual",
        "varieties": ["Maverick Series", "Rocky Mountain"]
    },
    "Ginger": {
        "spacing": "6-8\"",
        "depth": "1-2\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "240-300",
        "pests": "Aphids, spider mites, root knot nematodes",
        "companions": "Turmeric, galangal, cardamom, lemongrass, pigeon peas, bananas, teak, orchids",
        "sun": "Partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "2-3 feet",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [10,11,12],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Tropical rhizome, needs very warm conditions",
        "varieties": ["Zingiber officinale"]
    },
    "Ginseng": {
        "spacing": "6-8\"",
        "depth": "1/2-1\"",
        "soil": "Well-drained, rich, moist soil",
        "soilTemperature": "50-70°F",
        "whenToPlant": "Fall",
        "daysToMaturity": "1825-2190 (5-6 years)",
        "pests": "Slugs, deer, rodents",
        "companions": "Goldenseal, cohosh, wild ginger, ferns, trillium",
        "sun": "Shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": "1 -2",
        "height": "6-18 inches",
        "heightValue": 1,
        "shadeTolerance": "full",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [10,11],
        "plant": [4,5],
        "harvest": [9,10],
        "soilTempMin": 45,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": null,
        "notes": "Slow growing perennial, requires shade",
        "varieties": ["American Ginseng"]
    },
    "Good King Henry": {
        "spacing": "12-18\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "50-70°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "60-80",
        "pests": "Aphids, leaf miners, slugs",
        "companions": "Strawberries, herbs, tomatoes, beans",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "2-4 feet",
        "heightValue": 3,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [6,7,8,9],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Perennial spinach substitute",
        "varieties": ["Wild Spinach"]
    },
    "Green Beans": {
        "spacing": "3-6\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "60-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "50-60",
        "pests": "Bean beetles, Aphids, leafhoppers",
        "companions": "Corn, radishes, squash, cucumber, marigold, nasturtium, celery, carrots",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 9,
        "height": "2-3 feet (bush) or vining",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 0.75,
        "sow": [5,6,7],
        "plant": [5,6,7,8],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 14,
        "notes": "Same as bush beans - succession plant every 2 weeks",
        "varieties": ["Provider", "Contender", "Maxibel"]
    },
    "Ground Cherries": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "70-80",
        "pests": "Whiteflies, Flea beetles, Aphids",
        "companions": "Basil, parsley, carrots, onions, asparagus",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 75,
        "soilTempMax": 90,
        "successionInterval": null,
        "notes": "Physalis family, fruits drop when ripe",
        "varieties": ["Aunt Molly's", "Pineapple"]
    },
    "Hollyhocks": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "365-730 (1-2 years)",
        "pests": "Japanese beetles, Aphids, rust",
        "companions": "Sunflowers, cosmos, cleome, zinnias, rudbeckia",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "3 - 4",
        "height": "5-8 feet",
        "heightValue": 6.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 1,
        "sow": [3,4,5,6],
        "plant": [5,6,7],
        "harvest": [7,8,9],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Usually biennial, some annual varieties available",
        "varieties": ["Chater's Double", "Indian Spring"]
    },
    "Horseradish": {
        "spacing": "12-18\"",
        "depth": "4-6\"",
        "soil": "Deep, well-drained soil",
        "soilTemperature": "50-70°F",
        "whenToPlant": "Early spring or fall",
        "daysToMaturity": "140-160",
        "pests": "Flea beetles, Aphids, horseradish worms",
        "companions": "Potatoes, asparagus, rhubarb, sweet potatoes",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "2-3 feet (foliage)",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4],
        "plant": [4,5],
        "harvest": [10,11,12],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Perennial, grown from root cuttings",
        "varieties": ["Big Top", "Maliner Kren"]
    },
    "Hostas": {
        "spacing": "24-36\"",
        "depth": "1-2\"",
        "soil": "Rich, well-drained soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "365-730 (1-2 years)",
        "pests": "Slugs, snails, deer",
        "companions": "Astilbe, ferns, heuchera, impatiens, begonias, foxglove, primrose",
        "sun": "Partial to full shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "1p 2sqft",
        "height": "6 inches - 4 feet (depending on variety)",
        "heightValue": 2,
        "shadeTolerance": "full to partial",
        "shadeCreation": "very light to light",
        "shadeRadius": 1,
        "sow": [3,4],
        "plant": [5,6,9,10],
        "harvest": [6,7,8,9],
        "soilTempMin": 50,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Shade perennial, young shoots edible",
        "varieties": ["Blue Angel", "Patriot"]
    },
    "Hot Pepper": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "65-85",
        "pests": "Aphids, pepper maggots, thrips",
        "companions": "Basil, oregano, parsley, tomatoes, eggplant, onions, carrots",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [2,3,4],
        "plant": [5,6],
        "harvest": [7,8,9,10,11],
        "soilTempMin": 70,
        "soilTempOptimal": 85,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Hotter varieties need longer season than sweet peppers",
        "varieties": ["7 Pot Peppers", "Habanero", "Ghost Peppers", "RB003", "Carolina Reaper", "Red Ghost", "Tabasco"]
    },
    "Hubbard Squash": {
        "spacing": "36-48\"",
        "depth": "1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "100-120",
        "pests": "Squash bugs, cucumber beetles, squash vine borers",
        "companions": "Corn, beans, radishes, nasturtiums, marigolds, oregano, tansy",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "vining, spreads 10-20 feet",
        "heightValue": 15,
        "shadeTolerance": "none",
        "shadeCreation": "moderate to heavy",
        "shadeRadius": 3,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [9,10,11],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Large winter squash, needs full season",
        "varieties": ["Blue Hubbard", "Golden Hubbard", "Red Kuri"]
    },
    "Hydrangeas": {
        "spacing": "36-48\"",
        "depth": "2-3\"",
        "soil": "Rich, well-drained soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "730-1095 (2-3 years)",
        "pests": "Aphids, spider mites, scale",
        "companions": "Azaleas, hostas, ferns, astilbe, rhododendrons, boxwood",
        "sun": "Morning sun, afternoon shade",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": "1p 4sqft",
        "height": "3-10 feet (depending on variety)",
        "heightValue": 6.5,
        "shadeTolerance": "partial to full",
        "shadeCreation": "light to moderate",
        "shadeRadius": 2,
        "sow": [3,4],
        "plant": [5,6,9,10],
        "harvest": [6,7,8,9],
        "soilTempMin": 55,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Perennial shrub, flowers on old or new wood",
        "varieties": ["Endless Summer", "Annabelle", "Limelight"]
    },
    "Impatiens": {
        "spacing": "8-12\"",
        "depth": "1/8\"",
        "soil": "Rich, well-drained soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "55-70",
        "pests": "Aphids, spider mites, thrips",
        "companions": "Hostas, ferns, begonias, coleus, caladiums",
        "sun": "Partial to full shade",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": 12,
        "height": "6-24 inches",
        "heightValue": 1.25,
        "shadeTolerance": "full",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [2,3,4],
        "plant": [5,6],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Shade-loving annual flower",
        "varieties": ["Beacon Series", "Super Elfin"]
    },
    "Irises": {
        "spacing": "12-24\"",
        "depth": "1-2\"",
        "soil": "Well-drained soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Late summer to early fall",
        "daysToMaturity": "365 (1 year)",
        "pests": "Iris borers, thrips, leaf spot",
        "companions": "Peonies, columbines, lupines, poppies, salvia, lavender",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "1-4 feet (depending on variety)",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.5,
        "sow": [7,8,9],
        "plant": [8,9,10],
        "harvest": [5,6,7],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Perennial bulb, plant in late summer",
        "varieties": ["Bearded", "Siberian"]
    },
    "Jicama": {
        "spacing": "12-18\"",
        "depth": "1-2\"",
        "soil": "Well-drained, sandy soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "150-180",
        "pests": "Aphids, bean beetles, root-knot nematodes",
        "companions": "Corn, beans, tomatoes, squash",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "vining, up to 20 feet",
        "heightValue": 10,
        "shadeTolerance": "partial",
        "shadeCreation": "moderate",
        "shadeRadius": 2,
        "sow": [4,5,6],
        "plant": [5,6,7],
        "harvest": [10,11,12],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Tropical root crop, needs very long warm season",
        "varieties": ["Wayaka"]
    },
    "Kabocha Squash": {
        "spacing": "36-48\"",
        "depth": "1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "85-95",
        "pests": "Squash bugs, cucumber beetles, squash vine borers",
        "companions": "Corn, beans, radishes, nasturtiums, marigolds, oregano",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "vining, spreads 6-10 feet",
        "heightValue": 8,
        "shadeTolerance": "none",
        "shadeCreation": "moderate",
        "shadeRadius": 2,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [8,9,10,11],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Japanese winter squash variety",
        "varieties": ["Sunshine", "Red Kuri", "Black Futsu"]
    },
    "Kale": {
        "spacing": "12-18\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "55-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "50-65",
        "pests": "Cabbage worms, Aphids, Flea beetles",
        "companions": "Beets, celery, herbs, onions, spinach, chard, potatoes, dill, garlic",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4,7,8,9],
        "plant": [4,5,8,9,10],
        "harvest": [6,7,8,10,11,12],
        "soilTempMin": 40,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": 21,
        "notes": "Very cold hardy, cut and come again, succession plant",
        "varieties": ["Lacinato", "Curly", "Red Russian"]
    },
    "Kohlrabi": {
        "spacing": "4-6\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "55-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "45-60",
        "pests": "Cabbage worms, Aphids, Flea beetles",
        "companions": "Beets, lettuce, onions, dill, herbs, cucumber, celery",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5,7,8],
        "plant": [4,5,6,8,9],
        "harvest": [6,7,8,9,10,11],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": 14,
        "notes": "Cool season crop, succession plant for continuous harvest",
        "varieties": ["Early White Vienna", "Purple Vienna"]
    },
    "Kousa": {
        "spacing": "10-15 feet",
        "depth": "1-2\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring",
        "daysToMaturity": "1825-2190 (5-6 years)",
        "pests": "Scale insects, anthracnose, powdery mildew",
        "companions": "Azaleas, rhododendrons, hostas, ferns",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "15-30 feet (tree)",
        "heightValue": 22.5,
        "shadeTolerance": "partial",
        "shadeCreation": "moderate",
        "shadeRadius": 7.5,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 75,
        "soilTempMax": 90,
        "successionInterval": null,
        "notes": "Asian squash variety",
        "varieties": ["Kousa Dogwood"]
    },
    "Lambsquarters": {
        "spacing": "6-8\"",
        "depth": "1/4\"",
        "soil": "Almost any soil",
        "soilTemperature": "50-75°F",
        "whenToPlant": "Spring",
        "daysToMaturity": "30-40",
        "pests": "Aphids, leaf miners, slugs",
        "companions": "Corn, melons, cucumber, potatoes",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": 4,
        "height": "3-6 feet",
        "heightValue": 4.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1,
        "sow": [3,4,5,8,9],
        "plant": [3,4,5,8,9],
        "harvest": [5,6,7,9,10,11],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": 21,
        "notes": "Wild edible green, often self-seeding",
        "varieties": ["Magenta Spreen"]
    },
    "Lavender": {
        "spacing": "18-22\"",
        "depth": "1/4\"",
        "soil": "Well-drained, sandy soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "90-200",
        "pests": "Spittlebugs, Aphids, whiteflies",
        "companions": "Roses, rosemary, thyme, sage, oregano, marjoram, alliums, echinacea",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "none",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5],
        "plant": [5,6,9,10],
        "harvest": [6,7,8,9],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Perennial herb, drought tolerant once established",
        "varieties": ["Munstead", "Hidcote", "Phenomenal"]
    },
    "Leeks": {
        "spacing": "4\"",
        "depth": "1/2\"",
        "soil": "Well-drained soil, rich in organic matter",
        "soilTemperature": "55-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "105-110",
        "pests": "Leafminers, nematodes, Onion maggots, thrips",
        "companions": "Carrots, celery, onions, spinach, beets, lettuce, tomatoes, cabbage",
        "sun": "Full sun",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": 9,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [2,3,4],
        "plant": [5,6,7],
        "harvest": [9,10,11,12,1,2],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": 28,
        "notes": "Long season crop, very cold hardy",
        "varieties": ["King Richard", "Lancelot", "American Flag"]
    },
    "Lemon Balm": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "70-90",
        "pests": "Whiteflies, spider mites, powdery mildew",
        "companions": "Tomatoes, squash, broccoli, cauliflower, roses",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 55,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Perennial herb, can be invasive",
        "varieties": ["Common Lemon Balm", "Quedlinburger"]
    },
    "Lemongrass": {
        "spacing": "12-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "90-120",
        "pests": "Spider mites, Aphids, rust",
        "companions": "Galangal, ginger, turmeric, mangos, cucumbers, onions, tomatoes, peppers, eggplants",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "3-5 feet",
        "heightValue": 4,
        "shadeTolerance": "none",
        "shadeCreation": "light",
        "shadeRadius": 1,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [7,8,9,10,11],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Tropical grass, grow in containers in temperate zones",
        "varieties": ["West Indian"]
    },
    "Lettuce": {
        "spacing": "4-12\"",
        "depth": "1/8-1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "40-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "45-65",
        "pests": "Aphids, slugs, cutworms",
        "companions": "Beets, broccoli, beans, carrots, corn, peas, radishes, onions, asparagus, chives",
        "sun": "Full sun to partial shade",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": "1 - 4",
        "height": "6-18 inches",
        "heightValue": 1,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [2,3,4,5,8,9],
        "plant": [3,4,5,8,9],
        "harvest": [4,5,6,7,9,10,11],
        "soilTempMin": 35,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Cool season crop, essential for succession planting",
        "varieties": ["Buttercrunch", "Black Seeded Simpson", "Parris Island Cos"]
    },
    "Lilies": {
        "spacing": "6-8\"",
        "depth": "4-6\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "55-65°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "365 (1 year)",
        "pests": "Aphids, lily beetles, slugs",
        "companions": "Roses, peonies, irises, hostas, ferns, astilbe",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "3 - 4",
        "height": "2-6 feet (depending on variety)",
        "heightValue": 4,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [9,10,11],
        "plant": [10,11,12,3,4],
        "harvest": [6,7,8,9],
        "soilTempMin": 35,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": null,
        "notes": "Perennial bulbs, plant in fall for summer flowers",
        "varieties": ["Stargazer", "Casa Blanca"]
    },
    "Lima Beans": {
        "spacing": "4-6\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "65-75",
        "pests": "Bean beetles, Aphids, leafhoppers",
        "companions": "Corn, cucumbers, summer savory, radishes, nasturtiums",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "3 - 4",
        "height": "2-3 feet (bush) or vining",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 0.75,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 21,
        "notes": "Heat-loving legume, needs warmer soil than snap beans"
    },
    "Lovage": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring",
        "daysToMaturity": "85-95",
        "pests": "Aphids, celery worm, leaf miners, slugs",
        "companions": "Beans, brassicas, tomatoes, roses, carrots",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "3-7 feet",
        "heightValue": 5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 1,
        "sow": [3,4,5,8,9],
        "plant": [5,6,9,10],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 50,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Perennial herb, celery-like flavor",
        "varieties": ["Common Lovage"]
    },
    "Luffa": {
        "spacing": "36-48\"",
        "depth": "1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "150-200",
        "pests": "Cucumber beetles, squash bugs, Aphids",
        "companions": "Corn, beans, radishes, marigolds, nasturtiums",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "1p 2sqft",
        "height": "vining, up to 30 feet",
        "heightValue": 15,
        "shadeTolerance": "none",
        "shadeCreation": "moderate to heavy",
        "shadeRadius": 3,
        "sow": [4,5],
        "plant": [5,6],
        "harvest": [8,9,10,11],
        "soilTempMin": 70,
        "soilTempOptimal": 85,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Tropical vine, needs very long warm season for sponges",
        "varieties": ["Cylindrica", "Acutangular"]
    },
    "Mache": {
        "spacing": "2-5\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "40-70°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "45-60",
        "pests": "Aphids, slugs, Flea beetles",
        "companions": "Onions, carrots, radishes, leeks",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "4 - 9",
        "height": "4-8 inches",
        "heightValue": 0.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.1,
        "sow": [8,9,10],
        "plant": [8,9,10],
        "harvest": [10,11,12,1,2],
        "soilTempMin": 35,
        "soilTempOptimal": 50,
        "soilTempMax": 65,
        "successionInterval": 14,
        "notes": "Cold hardy salad green, corn salad",
        "varieties": ["Big Seeded", "Vit"]
    },
    "Marigolds": {
        "spacing": "8-12\"",
        "depth": "1/4\"",
        "soil": "Well-drained soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "50-60",
        "pests": "Aphids, spider mites, slugs",
        "companions": "Tomatoes, peppers, beans, cucumber, potatoes, squash, melons, strawberries",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 4,
        "height": "6 inches - 3 feet (depending on variety)",
        "heightValue": 1.75,
        "shadeTolerance": "none",
        "shadeCreation": "very light",
        "shadeRadius": 0.5,
        "sow": [4,5,6],
        "plant": [4,5,6,7],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": 28,
        "notes": "Easy annual flower, companion plant",
        "varieties": ["French", "African"]
    },
    "Marjoram": {
        "spacing": "6-12\"",
        "depth": "1/4\"",
        "soil": "Well-drained, sandy soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "80-90",
        "pests": "Aphids, spider mites, thrips",
        "companions": "All vegetables, beans, eggplant, pumpkins, squash",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Tender perennial herb, treat as annual",
        "varieties": ["Sweet Marjoram"]
    },
    "Mints": {
        "spacing": "4-12\"",
        "depth": "1/4\"",
        "soil": "Rich, moist soil",
        "soilTemperature": "55-70°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "90-110",
        "pests": "Spider mites, Aphids, Flea beetles",
        "companions": "Cabbage, tomatoes, broccoli, kale, cauliflower, kohlrabi",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "1 - 4",
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial to full",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5],
        "plant": [4,5,6],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 55,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Perennial herb, very invasive - contain in pots",
        "varieties": ["Peppermint", "Spearmint", "Chocolate Mint"]
    },
    "Morning Glories": {
        "spacing": "3-12\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "70-85",
        "pests": "Aphids, spider mites, leaf miners",
        "companions": "Sunflowers, sweet peas, moonflowers, cypress vine",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 4,
        "height": "vining, 6-15 feet",
        "heightValue": 10.5,
        "shadeTolerance": "none",
        "shadeCreation": "light to moderate",
        "shadeRadius": 2,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 75,
        "soilTempMax": 90,
        "successionInterval": null,
        "notes": "Annual vine, self-seeding",
        "varieties": ["Heavenly Blue", "Grandpa Ott's"]
    },
    "Mung Beans": {
        "spacing": "3-4\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "60-90",
        "pests": "Bean beetles, Aphids, leafhoppers",
        "companions": "Corn, squash, radishes, carrots, cucumber",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "16- 20",
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [7,8,9],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 21,
        "notes": "Heat-loving legume for sprouting or dried beans",
        "varieties": ["Berken", "Jade"]
    },
    "Mustard": {
        "spacing": "12-14\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "55-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "40-50",
        "pests": "Flea beetles, Aphids, cabbage worms",
        "companions": "Beets, celery, onions, herbs, carrots",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5,8,9],
        "plant": [3,4,5,8,9],
        "harvest": [5,6,7,9,10,11],
        "soilTempMin": 40,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": 14,
        "notes": "Fast-growing cool season green, excellent for succession",
        "varieties": ["Southern Giant Curled", "Florida Broadleaf"]
    },
    "Mustard Greens": {
        "spacing": "4-6\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "55-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "40-50",
        "pests": "Flea beetles, Aphids, cabbage worms",
        "companions": "Beets, celery, dill, onions, herbs, lettuce",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5,8,9],
        "plant": [3,4,5,8,9],
        "harvest": [5,6,7,9,10,11],
        "soilTempMin": 40,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": 14,
        "notes": "Same as mustard - duplicate entry",
        "varieties": ["Red Giant", "Mizuna"]
    },
    "Nasturtiums": {
        "spacing": "8-12\"",
        "depth": "1/2-1\"",
        "soil": "Well-drained, poor to moderately fertile soil",
        "soilTemperature": "55-65°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "55-65",
        "pests": "Aphids, cabbage worms, whiteflies",
        "companions": "Cucumber, tomatoes, cabbage, broccoli, radishes, squash, potatoes, beans",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": 4,
        "height": "6-12 inches (bush) or vining",
        "heightValue": 1,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [4,5,6],
        "plant": [5,6,7],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 55,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": 28,
        "notes": "Edible flowers, climbing or bush varieties",
        "varieties": ["Jewel Mix", "Empress of India"]
    },
    "Nettles": {
        "spacing": "12-18\"",
        "depth": "1/4\"",
        "soil": "Rich, moist soil",
        "soilTemperature": "50-70°F",
        "whenToPlant": "Spring",
        "daysToMaturity": "80-90",
        "pests": "Aphids, whiteflies, snails",
        "companions": "Tomatoes, herbs, fruit trees, broccoli",
        "sun": "Partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "2-7 feet",
        "heightValue": 4.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1,
        "sow": [3,4,5],
        "plant": [4,5,6],
        "harvest": [5,6,7,8,9],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Perennial wild edible, harvest young leaves with gloves",
        "varieties": ["Stinging Nettle"]
    },
    "Okra": {
        "spacing": "10-12\"",
        "depth": "1/2-1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "50-65",
        "pests": "Aphids, corn earworms, stink bugs",
        "companions": "Peppers, lettuce, squash, sweet potatoes, radishes, black-eyed peas",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "3-7 feet",
        "heightValue": 5,
        "shadeTolerance": "none",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [7,8,9,10],
        "soilTempMin": 70,
        "soilTempOptimal": 85,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Very heat-loving, drought tolerant once established",
        "varieties": ["Clemson Spineless", "Burgundy", "Annie Oakley"]
    },
    "Onions": {
        "spacing": "2-4\"",
        "depth": "1/2-1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "55-75°F",
        "whenToPlant": "Early spring",
        "daysToMaturity": "90-120",
        "pests": "Onion maggots, thrips, nematodes",
        "companions": "Beets, brassicas, carrots, lettuce, parsnips, tomatoes, strawberries, peppers",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "2 - 4",
        "height": "1-2 feet (foliage)",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [2,3,4,9,10],
        "plant": [3,4,5,10,11],
        "harvest": [7,8,9,10],
        "soilTempMin": 35,
        "soilTempOptimal": 55,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Long season crop, plant sets or start from seed early",
        "varieties": ["Walla Walla", "Sweet Spanish", "Yellow Globe"]
    },
    "Oregano": {
        "spacing": "8-12\"",
        "depth": "1/4\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "80-90",
        "pests": "Aphids, spider mites, leafhoppers",
        "companions": "All vegetables, tomatoes, peppers, basil, rosemary, thyme, sage",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "none",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Perennial herb, cut and come again",
        "varieties": ["Greek", "Italian", "Golden"]
    },
    "Pak Choy": {
        "spacing": "6-12\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "55-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "45-50",
        "pests": "Cabbage worms, Flea beetles, Aphids",
        "companions": "Beans, peas, onions, garlic, carrots, celery",
        "sun": "Full sun to partial shade",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,8,9],
        "plant": [4,5,8,9],
        "harvest": [5,6,7,9,10,11],
        "soilTempMin": 40,
        "soilTempOptimal": 60,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Same as Bok Choy - duplicate entry",
        "varieties": ["Joi Choi", "Toy Choy"]
    },
    "Pansies": {
        "spacing": "10-12\"",
        "depth": "1/8\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "45-65°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "70-85",
        "pests": "Aphids, slugs, snails",
        "companions": "Spring bulbs, primrose, violas, lettuce, kale",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "4 - 6",
        "height": "6-12 inches",
        "heightValue": 0.75,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [7,8,9],
        "plant": [9,10,11],
        "harvest": [3,4,5,6],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 75,
        "successionInterval": null,
        "notes": "Cool season flower, plant fall for spring blooms",
        "varieties": ["Delta Series", "Majestic Giant"]
    },
    "Parsley": {
        "spacing": "6-8\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "50-85°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "70-90",
        "pests": "Aphids, parsleyworms, whiteflies",
        "companions": "Asparagus, beans, tomatoes, corn, peppers, onions, peas, carrots",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "6-18 inches",
        "heightValue": 1,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5,8,9],
        "plant": [4,5,6,9,10],
        "harvest": [6,7,8,9,10,11],
        "soilTempMin": 50,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": 28,
        "notes": "Biennial herb, cut and come again",
        "varieties": ["Italian Flat Leaf", "Curly"]
    },
    "Parsnip": {
        "spacing": "8-10\"",
        "depth": "1/4-1/2\"",
        "soil": "Deep, loose, well-drained soil",
        "soilTemperature": "50-70°F",
        "whenToPlant": "Early spring",
        "daysToMaturity": "100-130",
        "pests": "Carrot rust flies, Aphids, wireworms",
        "companions": "Radishes, peas, potatoes, pepper, beans, garlic, onions",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet (foliage)",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5],
        "plant": [3,4,5],
        "harvest": [10,11,12,1,2],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Long season root crop, sweetens after frost",
        "varieties": ["Hollow Crown", "All-American"]
    },
    "Patty Pan Squash": {
        "spacing": "24-36\"",
        "depth": "1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "45-60",
        "pests": "Squash bugs, cucumber beetles, squash vine borers",
        "companions": "Corn, beans, radishes, nasturtiums, marigolds, oregano",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "2-3 feet (bushy)",
        "heightValue": 2.5,
        "shadeTolerance": "none",
        "shadeCreation": "light",
        "shadeRadius": 1,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 21,
        "notes": "Summer squash variety, succession plant for continuous harvest",
        "varieties": ["Sunburst", "Early White Bush"]
    },
    "Pea": {
        "spacing": "2-3\"",
        "depth": "1\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "45-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "55-70",
        "pests": "Aphids, pea moths, birds",
        "companions": "Carrots, radishes, corn, cucumber, beans, turnips, lettuce, spinach",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 8,
        "height": "2-6 feet (vining or bush)",
        "heightValue": 4,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1,
        "sow": [2,3,4,8,9],
        "plant": [3,4,5,9,10],
        "harvest": [5,6,7,10,11],
        "soilTempMin": 35,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Same as Garden Peas - cool season legume",
        "varieties": ["Green Arrow", "Lincoln", "Little Marvel"]
    },
    "Peace Lily": {
        "spacing": "12-18\"",
        "depth": "1-2\"",
        "soil": "Well-drained, rich potting mix",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring",
        "daysToMaturity": "365 (1 year)",
        "pests": "Mealybugs, scale, spider mites",
        "companions": "Ferns, pothos, philodendron, dracaena",
        "sun": "Partial to full shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "full",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [6,7,8,9,10,11,12],
        "soilTempMin": 70,
        "soilTempOptimal": 75,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Tropical houseplant, not for outdoor cultivation in temperate zones",
        "varieties": ["Spathiphyllum"]
    },
    "Peanuts": {
        "spacing": "24-36\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, sandy soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "120-150",
        "pests": "Aphids, thrips, nematodes",
        "companions": "Squash, beets, radishes, carrots, tansy, lettuce",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "none",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [9,10,11],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Heat-loving legume, needs long warm season",
        "varieties": ["Spanish", "Virginia", "Tennessee Red"]
    },
    "Peonies": {
        "spacing": "36-48\"",
        "depth": "1-2\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Fall",
        "daysToMaturity": "730-1095 (2-3 years)",
        "pests": "Botrytis blight, scale, ants",
        "companions": "Roses, irises, alliums, foxgloves, dahlias, coral bells",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": "1p 4sqft",
        "height": "2-4 feet",
        "heightValue": 3,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 1,
        "sow": [8,9,10],
        "plant": [9,10,11],
        "harvest": [5,6,7],
        "soilTempMin": 35,
        "soilTempOptimal": 50,
        "soilTempMax": 70,
        "successionInterval": null,
        "notes": "Perennial bulb, plant in fall, blooms in spring",
        "varieties": ["Sarah Bernhardt", "Festiva Maxima"]
    },
    "Peppers": {
        "spacing": "12-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "60-90",
        "pests": "Aphids, pepper maggots, thrips",
        "companions": "Basil, marjoram, oregano, carrots, eggplant, onions, tomatoes, parsley",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [2,3,4],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "General pepper category - see specific varieties",
        "varieties": ["Bell", "Jalapeno", "Banana", "Habanero"]
    },
    "Petunias": {
        "spacing": "10-12\"",
        "depth": "1/8\"",
        "soil": "Well-drained soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "60-75",
        "pests": "Aphids, slugs, tobacco budworms",
        "companions": "Tomatoes, peppers, beans, corn, grapes, dahlias, zinnias",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "6-24 inches (spreading or mounding)",
        "heightValue": 1.25,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.5,
        "sow": [2,3,4],
        "plant": [5,6],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Popular annual flower, many varieties",
        "varieties": ["Wave Series", "Supertunia"]
    },
    "Pimento": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "70-80",
        "pests": "Aphids, pepper maggots, spider mites",
        "companions": "Basil, tomatoes, carrots, onions, parsley",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "2-3 feet",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [2,3,4],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Sweet pepper variety for stuffing olives",
        "varieties": ["Sheepnose", "Pimento L"]
    },
    "Pineapple": {
        "spacing": "24-36\"",
        "depth": "2-3\"",
        "soil": "Well-drained, sandy soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Spring",
        "daysToMaturity": "730-1095 (2-3 years)",
        "pests": "Mealybugs, scale, root-knot nematodes",
        "companions": "Citrus, bananas, coffee, ginger, sweet potatoes",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": "1p 2sqft",
        "height": "2-5 feet",
        "heightValue": 3.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 1,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [24,30,36],
        "soilTempMin": 75,
        "soilTempOptimal": 85,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Tropical fruit, not suitable for temperate outdoor cultivation",
        "varieties": ["Smooth Cayenne"]
    },
    "Pole Beans": {
        "spacing": "4-6\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "60-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "55-65",
        "pests": "Bean beetles, Aphids, leafhoppers",
        "companions": "Corn, radishes, marigolds, nasturtiums, tansy, rosemary, squash",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 9,
        "height": "6-10 feet (vine)",
        "heightValue": 8,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1.5,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 21,
        "notes": "Climbing beans, longer harvest than bush types",
        "varieties": ["Kentucky Wonder", "Blue Lake", "Scarlet Runner"]
    },
    "Popcorn": {
        "spacing": "8-12\"",
        "depth": "1-2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "85-120",
        "pests": "Corn earworms, corn borers, Aphids",
        "companions": "Beans, squash, cucumber, melons, parsley, pumpkins",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "5-12 feet",
        "heightValue": 8.5,
        "shadeTolerance": "none",
        "shadeCreation": "moderate",
        "shadeRadius": 1,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 14,
        "notes": "Corn variety, harvest when kernels are hard and dry",
        "varieties": ["Strawberry", "Glass Gem", "Tom Thumb"]
    },
    "Poppy": {
        "spacing": "6-12\"",
        "depth": "1/8\"",
        "soil": "Well-drained soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring or fall",
        "daysToMaturity": "60-90",
        "pests": "Aphids, thrips, seed pod weevils",
        "companions": "Larkspur, cornflowers, sweet peas, roses, peonies",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 4,
        "height": "1-4 feet",
        "heightValue": 2.5,
        "shadeTolerance": "none",
        "shadeCreation": "very light",
        "shadeRadius": 0.5,
        "sow": [3,4,5,9,10],
        "plant": [4,5,6,10,11],
        "harvest": [6,7,8],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 75,
        "successionInterval": 28,
        "notes": "Cool season flower, direct sow, self-seeding",
        "varieties": ["California", "Shirley", "Flanders"]
    },
    "Potato": {
        "spacing": "12-16\"",
        "depth": "4-6\"",
        "soil": "Well-drained, loose, fertile soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring",
        "daysToMaturity": "70-120",
        "pests": "Colorado potato beetles, Aphids, wireworms",
        "companions": "Beans, corn, cabbage, horseradish, marigold, parsley, basil, thyme",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-3 feet (foliage)",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4,5],
        "plant": [4,5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": 14,
        "notes": "Plant seed potatoes, hill soil as plants grow",
        "varieties": ["Yukon Gold", "Russet", "Red Pontiac"]
    },
    "Potatoes": {
        "spacing": "12-16\"",
        "depth": "4-6\"",
        "soil": "Well-drained, loose, fertile soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring",
        "daysToMaturity": "70-120",
        "pests": "Colorado potato beetles, Aphids, wireworms",
        "companions": "Basil, beans, cabbage, corn, horseradish, lettuce, marigold, parsley, thyme",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-3 feet (foliage)",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4,5],
        "plant": [4,5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": 14,
        "notes": "Same as Potato - duplicate entry",
        "varieties": ["Yukon Gold", "Russet", "Red Pontiac"]
    },
    "Primrose": {
        "spacing": "6-12\"",
        "depth": "1/8\"",
        "soil": "Rich, moist, well-drained soil",
        "soilTemperature": "55-65°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "90-120",
        "pests": "Aphids, slugs, snails",
        "companions": "Hostas, ferns, astilbe, hellebores, spring bulbs",
        "sun": "Partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "6-18 inches",
        "heightValue": 1,
        "shadeTolerance": "partial to full",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [6,7,8],
        "plant": [9,10,11],
        "harvest": [3,4,5,6],
        "soilTempMin": 50,
        "soilTempOptimal": 60,
        "soilTempMax": 75,
        "successionInterval": null,
        "notes": "Cool season perennial flower",
        "varieties": ["English Primrose", "Evening Primrose"]
    },
    "Pumpkin": {
        "spacing": "36-60\"",
        "depth": "1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "90-120",
        "pests": "Squash bugs, cucumber beetles, squash vine borers",
        "companions": "Corn, beans, radishes, nasturtiums, marigolds, oregano, tansy",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "1p 2-4sqft",
        "height": "vining, spreads 10-20 feet",
        "heightValue": 15,
        "shadeTolerance": "none",
        "shadeCreation": "moderate to heavy",
        "shadeRadius": 3,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [9,10,11],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Large winter squash, needs full growing season",
        "varieties": ["Sugar Baby", "Baby Pam", "Autumn Gold", "Lumina", "Small Sugar"]
    },
    "Pumpkins": {
        "spacing": "36-60\"",
        "depth": "1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "90-120",
        "pests": "Squash bugs, cucumber beetles, squash vine borers",
        "companions": "Corn, beans, radishes, nasturtiums, marigolds, oregano, tansy, melons",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "1p 2-4sqft",
        "height": "vining, spreads 10-20 feet",
        "heightValue": 15,
        "shadeTolerance": "none",
        "shadeCreation": "moderate to heavy",
        "shadeRadius": 3,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [9,10,11],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Same as Pumpkin - duplicate entry",
        "varieties": ["Sugar Baby", "Baby Pam", "Autumn Gold", "Lumina", "Small Sugar"]
    },
    "Purslane": {
        "spacing": "6-8\"",
        "depth": "1/8\"",
        "soil": "Well-drained soil",
        "soilTemperature": "60-75°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "30-45",
        "pests": "Aphids, purslane sawfly, leaf miners",
        "companions": "Corn, radishes, turnips, lettuce, cucumber",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 4,
        "height": "2-6 inches (spreading)",
        "heightValue": 0.3,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [5,6,7],
        "plant": [5,6,7,8],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 75,
        "soilTempMax": 90,
        "successionInterval": 21,
        "notes": "Heat-loving succulent green, cut and come again",
        "varieties": ["Golden", "Garden Purslane"]
    },
    "Radicchio": {
        "spacing": "6-12\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "60-90",
        "pests": "Aphids, slugs, cutworms",
        "companions": "Beans, lettuce, onions, tomatoes, carrots",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 2,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [6,7,8],
        "plant": [7,8,9],
        "harvest": [9,10,11,12],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Cool season bitter green, fall crop",
        "varieties": ["Palla Rossa", "Treviso"]
    },
    "Radish": {
        "spacing": "1-2\"",
        "depth": "1/2\"",
        "soil": "Well-drained, loose soil",
        "soilTemperature": "50-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "21-30",
        "pests": "Flea beetles, root maggots, Aphids",
        "companions": "Peas, nasturtium, lettuce, cucumber, carrots, beans, melons, tomatoes, chervil",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 16,
        "height": "6-12 inches (foliage)",
        "heightValue": 0.75,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5,8,9,10],
        "plant": [3,4,5,8,9,10],
        "harvest": [4,5,6,7,9,10,11,12],
        "soilTempMin": 40,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": 7,
        "notes": "Fast-growing, excellent for succession planting",
        "varieties": ["Cherry Belle", "French Breakfast"]
    },
    "Radishes": {
        "spacing": "1-2\"",
        "depth": "1/2\"",
        "soil": "Well-drained, loose soil",
        "soilTemperature": "50-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "21-30",
        "pests": "Flea beetles, root maggots, Aphids",
        "companions": "Carrots, beans, lettuce, onions, tomatoes, peppers, cucumber, spinach",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 16,
        "height": "6-12 inches (foliage)",
        "heightValue": 0.75,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5,8,9,10],
        "plant": [3,4,5,8,9,10],
        "harvest": [4,5,6,7,9,10,11,12],
        "soilTempMin": 40,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": 7,
        "notes": "Same as Radish - duplicate entry",
        "varieties": ["Cherry Belle", "French Breakfast"]
    },
    "Rhubarb": {
        "spacing": "36-48\"",
        "depth": "1-2\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "50-70°F",
        "whenToPlant": "Early spring or fall",
        "daysToMaturity": "365 (1 year)",
        "pests": "Rhubarb curculio, crown rot, slugs",
        "companions": "Asparagus, garlic, onions, beans, horseradish",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "2-4 feet (foliage)",
        "heightValue": 3,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 1,
        "sow": [3,4],
        "plant": [4,5,9,10],
        "harvest": [4,5,6,7,8],
        "soilTempMin": 40,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": null,
        "notes": "Perennial vegetable, harvest leaf stalks only",
        "varieties": ["Valentine", "Canada Red", "Crimson Red", "White Victoria"]
    },
    "Romaine-Lettuce": {
        "spacing": "6-8\"",
        "depth": "1/8-1/4\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "45-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "65-80",
        "pests": "Aphids, slugs, cutworms",
        "companions": "Carrots, radishes, strawberries, cucumber, onions, chives, garlic",
        "sun": "Full sun to partial shade",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5,8,9],
        "plant": [3,4,5,8,9],
        "harvest": [5,6,7,9,10,11],
        "soilTempMin": 35,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Heat-tolerant lettuce variety",
        "varieties": ["Parris Island Cos", "Little Gem"]
    },
    "Romano Beans": {
        "spacing": "4-6\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "60-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "55-65",
        "pests": "Bean beetles, Aphids, leafhoppers",
        "companions": "Corn, squash, cucumber, radishes, carrots, marigolds",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "2-3 feet (bush) or vining",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 0.75,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 14,
        "notes": "Italian flat bean variety",
        "varieties": ["Dragon Tongue", "Roma II"]
    },
    "Rosemary": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, sandy soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "80-180",
        "pests": "Spider mites, Aphids, whiteflies",
        "companions": "Beans, cabbage, carrots, sage, parsley, thyme, lavender, oregano",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "2-4 feet",
        "heightValue": 3,
        "shadeTolerance": "none",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [6,7,8,9,10,11,12],
        "soilTempMin": 65,
        "soilTempOptimal": 75,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Perennial herb, not cold hardy, grow in pots",
        "varieties": ["Arp", "Tuscan Blue"]
    },
    "Roses": {
        "spacing": "24-36\"",
        "depth": "12-18\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "120-180",
        "pests": "Aphids, Japanese beetles, thrips",
        "companions": "Garlic, chives, marigolds, geraniums, lavender, catmint, sage, parsley",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "1p 2sqft",
        "height": "1-20+ feet (depending on type)",
        "heightValue": 5,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1.5,
        "sow": [3,4],
        "plant": [4,5,9,10],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 50,
        "soilTempOptimal": 65,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Perennial shrub, usually propagated by grafting",
        "varieties": ["Knock Out", "Peace", "Mr. Lincoln"]
    },
    "Runner Beans": {
        "spacing": "4-6\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "60-75°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "60-80",
        "pests": "Bean beetles, Aphids, leafhoppers",
        "companions": "Corn, squash, radishes, marigold, nasturtium, strawberries, celery",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 2,
        "height": "6-12feet (vine)",
        "heightValue": 9,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 2,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 75,
        "soilTempMax": 90,
        "successionInterval": 21,
        "notes": "Climbing bean variety, ornamental flowers",
        "varieties": ["Scarlet Runner", "Painted Lady"]
    },
    "Rue": {
        "spacing": "12-18\"",
        "depth": "1/4\"",
        "soil": "Well-drained, sandy soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "80-100",
        "pests": "Butterfly caterpillars",
        "companions": "Basil, marigolds, figs, roses",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "2-3 feet",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Perennial herb, natural pest deterrent - WARNING: Can cause skin irritation",
        "varieties": ["Common Rue"]
    },
    "Rutabagas": {
        "spacing": "2-8\"",
        "depth": "1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "50-70°F",
        "whenToPlant": "Mid-summer for fall harvest",
        "daysToMaturity": "90-100",
        "pests": "Flea beetles, cabbage root maggots, Aphids",
        "companions": "Onions, garlic, peas, nasturtiums, turnips",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet (foliage)",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [6,7,8],
        "plant": [6,7,8],
        "harvest": [10,11,12,1],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Cool season root crop, improves with frost",
        "varieties": ["American Purple Top", "Joan"]
    },
    "Sage": {
        "spacing": "12-18\"",
        "depth": "1/4\"",
        "soil": "Well-drained, sandy soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "75-90",
        "pests": "Aphids, spider mites, spittlebugs",
        "companions": "Rosemary, cabbage, carrots, beans, peas, strawberries",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [6,7,8,9,10,11],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Perennial herb, drought tolerant once established",
        "varieties": ["Broadleaf", "Berggarten", "Tricolor"]
    },
    "Salsify": {
        "spacing": "2-4\"",
        "depth": "1/2\"",
        "soil": "Deep, loose, well-drained soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring",
        "daysToMaturity": "120-150",
        "pests": "Carrot rust flies, wireworms, Aphids",
        "companions": "Carrots, lettuce, leeks, onions, radishes",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "4 - 6 ",
        "height": "2-3 feet (foliage)",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5],
        "plant": [3,4,5],
        "harvest": [10,11,12,1],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Long season root crop, oyster plant",
        "varieties": ["Sandwich Island"]
    },
    "Savory": {
        "spacing": "6-12\"",
        "depth": "1/4\"",
        "soil": "Well-drained soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "60-70",
        "pests": "Aphids, spider mites, leafhoppers",
        "companions": "Beans, onions, tomatoes, peppers",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "6-18 inches",
        "heightValue": 1,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": 28,
        "notes": "Annual herb, summer savory",
        "varieties": ["Summer Savory", "Winter Savory"]
    },
    "Scallions": {
        "spacing": "2-3\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "60-80",
        "pests": "Onion maggots, thrips, nematodes",
        "companions": "Beets, cabbage, carrots, lettuce, strawberries, tomatoes",
        "sun": "Full sun",
        "water": "2-3 times per week",
        "plantsPerSquareFoot": 16,
        "height": "1-2 feet (foliage)",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5,8,9],
        "plant": [3,4,5,8,9],
        "harvest": [5,6,7,8,9,10,11],
        "soilTempMin": 35,
        "soilTempOptimal": 55,
        "soilTempMax": 85,
        "successionInterval": 14,
        "notes": "Green onions, excellent for succession planting",
        "varieties": ["Hardy White", "Tokyo White"]
    },
    "Shallots": {
        "spacing": "6-8\"",
        "depth": "1-2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Early spring or fall",
        "daysToMaturity": "90-120",
        "pests": "Onion maggots, thrips, nematodes",
        "companions": "Beets, cabbage, carrots, lettuce, strawberries, tomatoes, peppers",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "1-2 feet (foliage)",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [2,3,9,10],
        "plant": [3,4,10,11],
        "harvest": [7,8,9],
        "soilTempMin": 35,
        "soilTempOptimal": 55,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Plant sets in early spring or fall",
        "varieties": ["Dutch Yellow", "French Red"]
    },
    "Snap Peas": {
        "spacing": "2-3\"",
        "depth": "1\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "45-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "55-70",
        "pests": "Aphids, pea moths, birds",
        "companions": "Carrots, radishes, corn, cucumber, turnips, beans",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "4 - 9",
        "height": "2-6 feet (vining or bush)",
        "heightValue": 4,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1,
        "sow": [2,3,4,8,9],
        "plant": [3,4,5,9,10],
        "harvest": [5,6,7,10,11],
        "soilTempMin": 35,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Edible pod pea variety, succession plant",
        "varieties": ["Sugar Snap", "Cascadia", "Super Sugar Snap"]
    },
    "Snapdragons": {
        "spacing": "6-12\"",
        "depth": "1/8\"",
        "soil": "Well-drained soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "75-90",
        "pests": "Aphids, rust, spider mites",
        "companions": "Dahlias, zinnias, marigolds, salvia, cosmos",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 9,
        "height": "1-3 feet",
        "heightValue": 2,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [2,3,4],
        "plant": [4,5,6],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 55,
        "soilTempOptimal": 65,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Cool season annual flower",
        "varieties": ["Rocket Series", "Liberty Classic"]
    },
    "Snow Peas": {
        "spacing": "2-3\"",
        "depth": "1\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "45-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "55-70",
        "pests": "Aphids, pea moths, powdery mildew",
        "companions": "Carrots, radishes, corn, cucumber, turnips, lettuce",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "4 - 9",
        "height": "2-6 feet (vining or bush)",
        "heightValue": 4,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1,
        "sow": [2,3,4,8,9],
        "plant": [3,4,5,9,10],
        "harvest": [5,6,7,10,11],
        "soilTempMin": 35,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Flat edible pod pea, cool season crop",
        "varieties": ["Oregon Sugar Pod II", "Mammoth Melting"]
    },
    "Sorrel": {
        "spacing": "3-12\"",
        "depth": "1/4\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "50-70°F",
        "whenToPlant": "Early spring",
        "daysToMaturity": "60-70",
        "pests": "Aphids, leafminers, slugs",
        "companions": "Strawberries, tomatoes, herbs, cabbage",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "4 - 9",
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5,8,9],
        "plant": [4,5,6,9,10],
        "harvest": [5,6,7,8,9,10],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Perennial sour-tasting green, cut and come again",
        "varieties": ["French", "Garden Sorrel"]
    },
    "Spinach": {
        "spacing": "3-5\"",
        "depth": "1/2\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "45-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "40-45",
        "pests": "Aphids, leafminers, slugs",
        "companions": "Strawberries, beans, peas, radishes, carrots, cabbage, cauliflower, celery",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 9,
        "height": "6-12 inches",
        "heightValue": 0.75,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [2,3,4,5,8,9,10],
        "plant": [3,4,5,8,9,10],
        "harvest": [4,5,6,7,9,10,11,12],
        "soilTempMin": 35,
        "soilTempOptimal": 50,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Cool season crop, bolts in heat, excellent for succession",
        "varieties": ["Bloomsdale Long Standing", "Tyee", "Giant Noble"]
    },
    "Squash": {
        "spacing": "24-36\"",
        "depth": "1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "50-100",
        "pests": "Squash bugs, cucumber beetles, squash vine borers",
        "companions": "Corn, beans, radishes, nasturtiums, marigolds, oregano, tansy",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "2-3 feet (bush) or vining (variable)",
        "heightValue": 2.5,
        "shadeTolerance": "none to partial (depending on type)",
        "shadeCreation": "light to heavy (depending on type)",
        "shadeRadius": 1.5,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [7,8,9,10,11],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 21,
        "notes": "General category - see specific varieties",
        "varieties": ["Butternut", "Spaghetti"]
    },
    "Stevia": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, loamy soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "90-100",
        "pests": "Aphids, whiteflies, spider mites",
        "companions": "Basil, thyme, marjoram, oregano",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "2-3 feet",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 75,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Sweet herb, tender perennial",
        "varieties": ["Sweet Leaf"]
    },
    "Strawberries": {
        "spacing": "6-18\"",
        "depth": "1/4\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "60-75°F",
        "whenToPlant": "Early spring or fall",
        "daysToMaturity": "120-160",
        "pests": "Slugs, spider mites, Aphids",
        "companions": "Beans, borage, lettuce, onions, spinach, thyme, sage",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "1 - 2",
        "height": "6-12 inches (spreading)",
        "heightValue": 0.75,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.5,
        "sow": [2,3,4],
        "plant": [4,5,8,9],
        "harvest": [6,7,8,9],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": null,
        "notes": "Perennial fruit, usually grown from plants",
        "varieties": ["Quinault", "Chandler"]
    },
    "Sugar Snap Peas": {
        "spacing": "2-3\"",
        "depth": "1\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "45-65°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "55-70",
        "pests": "Aphids, pea moths, birds",
        "companions": "Carrots, radishes, corn, cucumber, turnips, lettuce, onions",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 9,
        "height": "2-6 feet (vining or bush)",
        "heightValue": 4,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1,
        "sow": [2,3,4,8,9],
        "plant": [3,4,5,9,10],
        "harvest": [5,6,7,10,11],
        "soilTempMin": 35,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Sweet edible pod pea variety",
        "varieties": ["Sugar Ann", "Sugar Daddy"]
    },
    "Summer Squash": {
        "spacing": "12-24\"",
        "depth": "1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "50-65",
        "pests": "Squash bugs, cucumber beetles, squash vine borers",
        "companions": "Corn, beans, radishes, nasturtiums, marigolds, oregano, dill",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "2-4 feet (bushy)",
        "heightValue": 3,
        "shadeTolerance": "none",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1,
        "sow": [5,6,7],
        "plant": [5,6,7,8],
        "harvest": [7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 21,
        "notes": "Zucchini, yellow squash, etc. Succession plant for continuous harvest",
        "varieties": ["Yellow Crookneck", "Zucchini"]
    },
    "Sunflowers": {
        "spacing": "3-24\"",
        "depth": "1\"",
        "soil": "Well-drained soil",
        "soilTemperature": "55-65°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "80-120",
        "pests": "Aphids, sunflower beetles, birds",
        "companions": "Corn, cucumber, melons, squash, beans, cosmos, zinnias",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": "1 - 4",
        "height": "5-12 feet",
        "heightValue": 8.5,
        "shadeTolerance": "none",
        "shadeCreation": "heavy",
        "shadeRadius": 3,
        "sow": [5,6,7],
        "plant": [5,6,7,8],
        "harvest": [8,9,10,11],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 90,
        "successionInterval": 14,
        "notes": "Annual flower, succession plant for cut flowers",
        "varieties": ["Mammoth Grey Stripe", "Autumn Beauty", "Teddy Bear"]
    },
    "Sweet Corn": {
        "spacing": "8-12\"",
        "depth": "1-2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "70-100",
        "pests": "Corn earworms, corn borers, Aphids",
        "companions": "Beans, squash, cucumber, peas, melons, parsley, potatoes",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "5-8 feet",
        "heightValue": 6.5,
        "shadeTolerance": "none",
        "shadeCreation": "moderate",
        "shadeRadius": 1,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 14,
        "notes": "Same as corn, succession plant for extended harvest",
        "varieties": ["Silver Queen", "Honey Select"]
    },
    "Sweet Potatoes": {
        "spacing": "12-18\"",
        "depth": "3-4\"",
        "soil": "Well-drained, sandy soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "90-170",
        "pests": "Sweet potato weevils, wireworms, nematodes",
        "companions": "Beans, peas, oregano, parsley, thyme, black-eyed peas",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "vining, spreads 2-6 feet",
        "heightValue": 4,
        "shadeTolerance": "none",
        "shadeCreation": "light",
        "shadeRadius": 1.5,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [9,10,11],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Heat-loving vine, grown from slips",
        "varieties": ["Beauregard", "Georgia Jet", "Centennial"]
    },
    "Swiss Chard": {
        "spacing": "6-12\"",
        "depth": "1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "50-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "50-60",
        "pests": "Aphids, leafminers, Flea beetles",
        "companions": "Beans, brassicas, lavender, onions, roses, passion fruit, cauliflower",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "1-2 feet",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5,7,8],
        "plant": [4,5,6,8,9],
        "harvest": [6,7,8,9,10,11],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 85,
        "successionInterval": 21,
        "notes": "Heat-tolerant green, cut and come again",
        "varieties": ["Bright Lights", "Fordhook Giant", "Celebration", "Lucullus", "Ruby Red"]
    },
    "Tansy": {
        "spacing": "18-24\"",
        "depth": "1/4\"",
        "soil": "Well-drained, poor to average soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "90-120",
        "pests": "Few pests, very hardy",
        "companions": "Roses, fruit trees, potatoes, cabbage",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "3-4 feet",
        "heightValue": 3.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 50,
        "soilTempOptimal": 65,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Perennial herb, natural pest deterrent, can be invasive - WARNING: Toxic if consumed",
        "varieties": ["Common Tansy"]
    },
    "Tarragon": {
        "spacing": "12-18\"",
        "depth": "1/4\"",
        "soil": "Well-drained, sandy soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "90-120",
        "pests": "Whiteflies, spider mites, downy mildew",
        "companions": "Vegetables, eggplant, tomatoes, peppers",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "2-3 feet",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [6,7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Perennial herb, French tarragon preferred",
        "varieties": ["French", "Russian"]
    },
    "Tatsoi": {
        "spacing": "3-8\"",
        "depth": "1/4-1/2\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "50-75°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "45-50",
        "pests": "Cabbage worms, Flea beetles, Aphids",
        "companions": "Peas, spinach, strawberries, onions, lettuce",
        "sun": "Full sun to partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 9,
        "height": "6-12 inches (spreading)",
        "heightValue": 0.75,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,8,9],
        "plant": [4,5,8,9],
        "harvest": [5,6,7,9,10,11],
        "soilTempMin": 40,
        "soilTempOptimal": 60,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Asian green, very cold hardy, rosette shape",
        "varieties": ["Rosette Tatsoi"]
    },
    "Thyme": {
        "spacing": "8-12\"",
        "depth": "1/4\"",
        "soil": "Well-drained, sandy soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "90-180",
        "pests": "Spider mites, Aphids, whiteflies",
        "companions": "Cabbage, potatoes, eggplant, strawberries, tomatoes, roses, lavender",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 4,
        "height": "4-12 inches (spreading)",
        "heightValue": 0.75,
        "shadeTolerance": "none",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [6,7,8,9,10,11],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Perennial herb, drought tolerant, many varieties",
        "varieties": ["English", "French", "Lemon Thyme"]
    },
    "Tomatillos": {
        "spacing": "24-36\"",
        "depth": "1/4\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "75-100",
        "pests": "Aphids, Flea beetles, whiteflies",
        "companions": "Basil, oregano, parsley, peppers, onions, carrots, nasturtiums",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "1p 2sqft",
        "height": "3-4 feet",
        "heightValue": 3.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 1,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Heat-loving nightshade, needs cross-pollination",
        "varieties": ["Toma Verde", "Purple", "Pineapple"]
    },
    "Tomato": {
        "spacing": "24-36\"",
        "depth": "1/4\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "60-100",
        "pests": "Hornworms, Aphids, whiteflies",
        "companions": "Basil, beans, borage, carrots, celery, dill, lettuce, melons, radishes, spinach, chives",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "4-8 feet (depending on type)",
        "heightValue": 6,
        "shadeTolerance": "partial",
        "shadeCreation": "moderate",
        "shadeRadius": 2,
        "sow": [3,4],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 75,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Heat-loving nightshade, determinate vs indeterminate varieties",
        "varieties": ["Sungold", "Brandywine", "Early Girl", "Roma", "Celebrity"]
    },
    "Tulips": {
        "spacing": "6-8\"",
        "depth": "6-8\"",
        "soil": "Well-drained soil",
        "soilTemperature": "55-65°F",
        "whenToPlant": "Fall",
        "daysToMaturity": "150-180",
        "pests": "Aphids, slugs, tulip fire",
        "companions": "Daffodils, hyacinths, alliums, grape hyacinths, pansies, forget-me-nots",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": "5 - 9",
        "height": "6-30 inches (depending on variety)",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [10,11,12],
        "plant": [10,11,12],
        "harvest": [3,4,5],
        "soilTempMin": 35,
        "soilTempOptimal": 45,
        "soilTempMax": 60,
        "successionInterval": null,
        "notes": "Plant bulbs in fall for spring flowers, need cold period",
        "varieties": ["Darwin Hybrid", "Emperor"]
    },
    "Turmeric": {
        "spacing": "36-48\"",
        "depth": "2-3\"",
        "soil": "Well-drained, rich soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "240-300",
        "pests": "Aphids, spider mites, root-knot nematodes",
        "companions": "Ginger, galangal, cardamom, lemongrass, pigeon peas, bananas, chilli peppers",
        "sun": "Partial shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "1p 4sqft",
        "height": "2-3 feet",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [10,11,12],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Tropical rhizome, very long warm season required",
        "varieties": ["Curcuma longa"]
    },
    "Turnip": {
        "spacing": "3-4\"",
        "depth": "1/2\"",
        "soil": "Well-drained, loose soil",
        "soilTemperature": "50-70°F",
        "whenToPlant": "Early spring and fall",
        "daysToMaturity": "40-60",
        "pests": "Flea beetles, root maggots, Aphids",
        "companions": "Peas, broccoli, brussels sprouts, beans, onions, garlic, lettuce, nasturtiums",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 9,
        "height": "1-2 feet (foliage)",
        "heightValue": 1.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,7,8],
        "plant": [3,4,7,8],
        "harvest": [5,6,7,9,10,11],
        "soilTempMin": 40,
        "soilTempOptimal": 60,
        "soilTempMax": 80,
        "successionInterval": 21,
        "notes": "Cool season root crop, both roots and greens edible",
        "varieties": ["Purple Top White Globe", "Tokyo Cross"]
    },
    "Violets": {
        "spacing": "6-8\"",
        "depth": "1/4\"",
        "soil": "Rich, moist, well-drained soil",
        "soilTemperature": "50-70°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "90-120",
        "pests": "Aphids, slugs, spider mites",
        "companions": "Hostas, ferns, primrose, astilbe, spring bulbs",
        "sun": "Partial to full shade",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 4,
        "height": "4-8 inches (spreading)",
        "heightValue": 0.5,
        "shadeTolerance": "partial to full",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,8,9],
        "plant": [4,5,9,10],
        "harvest": [4,5,6,9,10],
        "soilTempMin": 45,
        "soilTempOptimal": 60,
        "soilTempMax": 75,
        "successionInterval": null,
        "notes": "Perennial edible flower, self-seeding",
        "varieties": ["Sweet Violet", "Johnny Jump Up"]
    },
    "Watercress": {
        "spacing": "4-6\"",
        "depth": "1/8\"",
        "soil": "Constantly moist soil",
        "soilTemperature": "50-65°F",
        "whenToPlant": "Spring",
        "daysToMaturity": "40-60",
        "pests": "Aphids, Flea beetles, whiteflies",
        "companions": "Chives, parsley, wintercress, water plants",
        "sun": "Partial shade",
        "water": "Daily",
        "plantsPerSquareFoot": 1,
        "height": "2-6 inches (spreading)",
        "heightValue": 0.3,
        "shadeTolerance": "partial",
        "shadeCreation": "very light",
        "shadeRadius": 0.25,
        "sow": [3,4,5,8,9],
        "plant": [3,4,5,8,9],
        "harvest": [4,5,6,7,9,10,11],
        "soilTempMin": 40,
        "soilTempOptimal": 55,
        "soilTempMax": 75,
        "successionInterval": 14,
        "notes": "Cool season aquatic green, needs constant moisture",
        "varieties": ["True Watercress"]
    },
    "Watermelon": {
        "spacing": "36-60\"",
        "depth": "1\"",
        "soil": "Well-drained, sandy soil",
        "soilTemperature": "70-90°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "70-100",
        "pests": "Cucumber beetles, squash bugs, Aphids",
        "companions": "Corn, nasturtiums, peas, sunflowers, squash, cucumbers, pumpkins, radishes, oregano",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "vining, spreads 6-15 feet",
        "heightValue": 10.5,
        "shadeTolerance": "none",
        "shadeCreation": "light to moderate",
        "shadeRadius": 2.5,
        "sow": [4,5],
        "plant": [5,6],
        "harvest": [7,8,9],
        "soilTempMin": 70,
        "soilTempOptimal": 85,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Very heat-loving vine, needs long warm season",
        "varieties": ["Sugar Baby", "Crimson Sweet", "Charleston Gray"]
    },
    "Wax Beans": {
        "spacing": "3-6\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, moderately fertile soil",
        "soilTemperature": "60-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "50-60",
        "pests": "Bean beetles, Aphids, leafhoppers",
        "companions": "Corn, squash, radishes, marigold, nasturtium, celery",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "5 - 9",
        "height": "2-3 feet (bush) or vining",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light to moderate",
        "shadeRadius": 0.75,
        "sow": [5,6,7],
        "plant": [5,6,7,8],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 14,
        "notes": "Yellow bean variety, same as green beans",
        "varieties": ["Cherokee Wax", "Golden Butterwax"]
    },
    "Winged Beans": {
        "spacing": "6-12\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "80-90",
        "pests": "Bean beetles, Aphids, leafhoppers",
        "companions": "Corn, okra, eggplant, tomatoes",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "6-15 feet (vining)",
        "heightValue": 10.5,
        "shadeTolerance": "partial",
        "shadeCreation": "moderate",
        "shadeRadius": 2,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [8,9,10],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Tropical climbing bean, all parts edible",
        "varieties": ["Dragon Bean"]
    },
    "Winter Squash": {
        "spacing": "36-48\"",
        "depth": "1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "80-120",
        "pests": "Squash bugs, cucumber beetles, squash vine borers",
        "companions": "Corn, beans, radishes, nasturtiums, marigolds, oregano, tansy",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "vining, spreads 6-15 feet",
        "heightValue": 10.5,
        "shadeTolerance": "none",
        "shadeCreation": "moderate to heavy",
        "shadeRadius": 2.5,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [9,10,11,12],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Long season vine crop, harvest before hard frost",
        "varieties": ["Butternut", "Acorn", "Spaghetti"]
    },
    "Wisteria": {
        "spacing": "10-15 feet",
        "depth": "2-3\"",
        "soil": "Well-drained, moist, fertile soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring or fall",
        "daysToMaturity": "730-1095 (2-3 years)",
        "pests": "Scale insects, Aphids, leaf miners",
        "companions": "Clematis, roses, honeysuckle, jasmine",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "6ft apart",
        "height": "vining, 20-30+ feet",
        "heightValue": 25,
        "shadeTolerance": "partial",
        "shadeCreation": "moderate to heavy",
        "shadeRadius": 5,
        "sow": [3,4],
        "plant": [5,6,9,10],
        "harvest": [5,6,7],
        "soilTempMin": 50,
        "soilTempOptimal": 65,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Perennial flowering vine, very vigorous",
        "varieties": ["American", "Chinese"]
    },
    "Wormwood": {
        "spacing": "12-18\"",
        "depth": "1/4\"",
        "soil": "Well-drained, sandy soil",
        "soilTemperature": "60-70°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "90-120",
        "pests": "Whiteflies, spider mites, downy mildew",
        "companions": "Vegetables, eggplant, tomatoes, peppers",
        "sun": "Full sun to partial shade",
        "water": "1 time per week",
        "plantsPerSquareFoot": 1,
        "height": "2-3 feet",
        "heightValue": 2.5,
        "shadeTolerance": "partial",
        "shadeCreation": "light",
        "shadeRadius": 0.5,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 70,
        "soilTempMax": 85,
        "successionInterval": null,
        "notes": "Perennial herb, natural pest deterrent, bitter taste",
        "varieties": ["Artemisia absinthium"]
    },
    "Yams": {
        "spacing": "12-18\"",
        "depth": "3-4\"",
        "soil": "Well-drained, sandy soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "120-180",
        "pests": "Sweet potato weevils, wireworms, nematodes",
        "companions": "Beans, peas, oregano, thyme, corn",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 4,
        "height": "vining, up to 50 feet",
        "heightValue": 25,
        "shadeTolerance": "partial",
        "shadeCreation": "moderate",
        "shadeRadius": 3,
        "sow": [3,4,5],
        "plant": [5,6],
        "harvest": [9,10,11],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Tropical tuber, different from sweet potatoes",
        "varieties": ["True Yam"]
    },
    "Yard-long Beans": {
        "spacing": "6-12\"",
        "depth": "1-1.5\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "65-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "80-90",
        "pests": "Bean beetles, Aphids, leafhoppers",
        "companions": "Corn, sunflowers, okra, radishes, marigolds",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "10-15 feet (vining)",
        "heightValue": 12.5,
        "shadeTolerance": "partial",
        "shadeCreation": "moderate",
        "shadeRadius": 2,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [7,8,9,10],
        "soilTempMin": 70,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 21,
        "notes": "Asian climbing bean, very long pods",
        "varieties": ["Red Noodle", "Orient Wonder"]
    },
    "Jalapenos": {
        "spacing": "12-18\"",
        "depth": "1/4\"",
        "soil": "Well-drained, fertile, loamy soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "2-3 weeks after last frost when soil is warm",
        "daysToMaturity": "70-80",
        "pests": "Aphids, flea beetles, cutworms, pepper hornworms",
        "companions": "Basil, marigolds, tomatoes, onions, carrots, nasturtiums",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": 1,
        "height": "2-3 feet",
        "heightValue": 3,
        "shadeTolerance": "partial",
        "shadeCreation": "medium",
        "shadeRadius": 1.0,
        "sow": [2,3,4],
        "plant": [5,6],
        "harvest": [7,8,9,10],
        "soilTempMin": 60,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": null,
        "notes": "Harvest when dark green for classic flavor or allow to ripen to red for increased sweetness and heat.",
        "varieties": ["Mucho Nacho", "Goliath", "TAM", "Coolapeno", "Hot Jalafuego"]
    },
    "Zinnias": {
        "spacing": "8-12\"",
        "depth": "1/4\"",
        "soil": "Well-drained soil",
        "soilTemperature": "65-75°F",
        "whenToPlant": "Spring after frost",
        "daysToMaturity": "60-75",
        "pests": "Aphids, Japanese beetles, powdery mildew",
        "companions": "Tomatoes, beans, dahlias, marigolds, cosmos, sunflowers, nasturtiums",
        "sun": "Full sun",
        "water": "1 time per week",
        "plantsPerSquareFoot": 4,
        "height": "6 inches - 4 feet",
        "heightValue": 2.25,
        "shadeTolerance": "none",
        "shadeCreation": "light",
        "shadeRadius": 0.75,
        "sow": [5,6],
        "plant": [5,6,7],
        "harvest": [7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 75,
        "soilTempMax": 90,
        "successionInterval": 14,
        "notes": "Easy annual flower, succession plant for cut flowers",
        "varieties": ["State Fair", "Benary's Giant"]
    },
    "Zucchini": {
        "spacing": "24-36\"",
        "depth": "1\"",
        "soil": "Well-drained, fertile soil",
        "soilTemperature": "70-85°F",
        "whenToPlant": "Late spring after frost",
        "daysToMaturity": "45-55",
        "pests": "Squash bugs, cucumber beetles, squash vine borers",
        "companions": "Corn, beans, radishes, nasturtiums, marigolds, oregano, dill, garlic",
        "sun": "Full sun",
        "water": "1-2 times per week",
        "plantsPerSquareFoot": "1p 2-4sqft",
        "height": "2-4 feet (bushy)",
        "heightValue": 3,
        "shadeTolerance": "none",
        "shadeCreation": "light to moderate",
        "shadeRadius": 1,
        "sow": [5,6,7],
        "plant": [5,6,7,8],
        "harvest": [7,8,9,10],
        "soilTempMin": 65,
        "soilTempOptimal": 80,
        "soilTempMax": 95,
        "successionInterval": 21,
        "notes": "Summer squash, very productive, succession plant for continuous harvest",
        "varieties": ["Black Beauty", "Fordhook", "Raven"]
    }
};

// If you're using Node.js/CommonJS
// module.exports = plantDatabase;

// If you're using ES modules
// export default plantDatabase;

export default plantDatabase;